export const Logo = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 224 254"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2)">
      <path
        d="M203.57 72.36C202.81 67.5 201.77 62.6 199.69 58.05C199.56 57.82 199.57 57.58 199.08 57.06C198.38 56.36 197.47 56.65 196.99 57.4C196.16 58.66 196.28 60.22 196.27 61.64C196.5 66.01 197.88 71.14 199.68 74.75C199.86 75.12 200.03 75.46 200.21 75.77C200.19 75.82 200.2 75.87 200.23 75.93C200.68 76.75 201.67 77.53 202.73 77.19C203.67 76.87 203.74 75.91 203.74 75.18C203.72 74.29 203.68 73.3 203.55 72.36H203.57ZM202.94 76.39C202.68 76.79 202.22 76.82 201.8 76.68C201.84 76.56 201.8 76.43 201.71 76.33C201.64 76.22 201.52 76.03 201.47 75.96C200.98 75.21 200.52 74.43 200.12 73.63C199 71.56 198.02 68.93 197.58 66.04C197.24 64.21 196.97 61.22 197.23 59.49C197.29 59.11 197.45 58.22 197.91 57.7C197.95 57.67 198.03 57.59 198.07 57.55C198.09 57.54 198.11 57.53 198.13 57.52C198.15 57.52 198.17 57.52 198.18 57.51C198.22 57.53 198.26 57.55 198.29 57.57C198.32 57.59 198.36 57.63 198.4 57.66C200.31 60.3 201.84 65.84 202.75 70.11C203.1 72.21 203.71 74.45 202.92 76.38L202.94 76.39Z"
        fill="url(#paint0_linear_1_2)"
      />
      <path
        d="M72.67 31.52C72.62 31.41 72.63 31.27 72.53 31.19C72.44 31.14 72.31 31.22 72.34 31.32C72.5 31.71 72.71 32.07 72.81 32.48C72.81 32.52 72.88 32.52 72.9 32.49C72.84 32.16 72.7 31.85 72.67 31.52Z"
        fill="url(#paint1_linear_1_2)"
      />
      <path
        d="M71.01 46.26C71.24 50.88 71.47 55.51 71.4 60.14C71.39 62.07 71.26 64 71.1 65.92C71.17 65.7 71.26 65.48 71.35 65.27C71.38 65.14 71.41 65.01 71.44 64.89C71.76 63.61 72.14 62.43 72.26 61.1C72.35 60.1 72.57 59.17 72.81 58.22C72.74 56.99 72.66 55.76 72.58 54.53C72.21 49.71 71.86 44.89 71.28 40.11C71.11 38.84 70.98 37.57 70.78 36.3C70.73 36.14 70.43 36.2 70.48 36.37C71.12 39.61 71 42.96 71.01 46.26Z"
        fill="url(#paint2_linear_1_2)"
      />
      <path
        d="M74.27 40.41C74.79 44.45 74.94 48.5 74.96 52.56C74.99 52.49 75.03 52.43 75.05 52.36C75.31 51.76 75.59 51.15 76.08 50.66C76.16 50.58 76.25 50.52 76.33 50.45C76.11 48.19 75.88 45.92 75.63 43.66C75.3 40.29 74.64 36.95 73.55 33.72C73.49 33.61 73.47 33.45 73.33 33.4C73.19 33.36 73.05 33.51 73.13 33.63C73.99 35.74 73.96 38.08 74.26 40.4L74.27 40.41Z"
        fill="url(#paint3_linear_1_2)"
      />
      <path
        d="M71.2 31.9C71.61 32.92 72.16 35.22 72.2 36.59C72.47 38.96 72.71 41.64 72.83 44.12C72.89 48.08 73.04 52.05 73.01 56.01C73.01 56.52 73.01 57 73 57.47C73.29 56.4 73.73 55.35 74.1 54.31C74.26 53.87 74.49 53.45 74.72 53.03C74.43 50.39 74.05 47.68 73.57 44.74C73.2 42.1 73.25 39.16 72.73 36.51C72.4 34.86 71.83 32.65 71.24 30.93C71.11 30.55 70.44 30.76 70.67 31.15C70.82 31.43 70.96 31.67 71.2 31.91V31.9Z"
        fill="url(#paint4_linear_1_2)"
      />
      <path
        d="M64.19 87.12C65.01 87.31 65.85 87.59 66.64 87.97C66.65 87.74 66.66 87.51 66.68 87.28C66.72 86.28 66.77 85.28 66.81 84.28C66.83 85.55 66.85 86.82 66.89 88.09C67.62 88.46 68.27 88.91 68.83 89.44C69.21 89.46 69.57 89.57 69.87 89.76C69.92 88.41 69.9 86.94 69.84 85.48C70 87.03 70.2 88.55 70.45 90.03C70.49 90.19 70.52 90.33 70.56 90.47C70.58 90.5 70.6 90.53 70.61 90.56C70.49 89.57 70.4 88.58 70.34 87.6C70.27 86.39 70.23 85.18 70.22 83.97C69.99 82.73 69.78 81.49 69.63 80.24C69.27 77.26 69.6 74.12 69.95 71.15C70.11 69.8 70.31 68.46 70.72 67.15C70.72 67.13 70.73 67.11 70.74 67.09C70.47 63.56 70.7 59.14 70.47 55.28C70.02 51.35 69.57 47.06 69.36 42.97C69.13 40.44 68.75 37.85 68.39 35.36C68.23 34.37 68.18 33.34 67.81 32.4C67.66 32.22 67.3 32.36 67.38 32.59C68.77 37.4 68.57 42.49 68.92 47.48C69.55 57.72 68.92 68.96 69.39 79.25C68.99 74.44 68.52 67.76 68.33 62.82C68.43 59.09 68.56 55.35 68.29 51.62C67.89 47.62 67.17 43.65 66.87 39.64C66.66 37.47 66.63 35.27 66.11 33.14C66.08 33.07 66.11 32.96 66.02 32.92C65.98 32.91 65.93 32.94 65.93 32.98C67.08 42.34 67.46 51.78 67.37 61.2C67.19 65.63 67 70.07 66.89 74.51C66.72 71.82 66.39 69.14 66.34 66.45C66.11 58.18 65.63 49.92 64.96 41.67C64.86 40.89 64.32 31.79 63.6 33.55C65.4 41.3 65.26 49.36 65.12 57.26C65.15 65.7 65.15 74.13 64.5 82.55C64.39 83.92 64.27 85.52 64.19 87.1V87.12Z"
        fill="url(#paint5_linear_1_2)"
      />
      <path
        d="M70.24 32.63C70.05 32.37 69.58 32.59 69.68 32.88C69.77 33.12 69.76 33.41 69.89 33.63C70.02 33.81 70.36 33.75 70.42 33.54C70.42 33.4 70.4 32.94 70.25 32.63H70.24Z"
        fill="url(#paint6_linear_1_2)"
      />
      <path
        d="M60.84 86.88C61.5 86.82 62.16 86.82 62.81 86.88C63.11 86.91 63.43 86.96 63.75 87.02C63.67 82.18 63.4 77.01 63.51 72.33C63.25 67.32 63.56 62.32 63.56 57.32C63.6 52.07 63.2 46.83 62.97 41.58C62.78 39.21 62.49 36.84 62.33 34.47C62.21 34.08 62.47 33.49 62.03 33.27C61.81 33.21 61.57 33.41 61.64 33.62C64.56 48.47 61.75 63.65 61.55 78.63C61.3 81.37 61.04 84.12 60.83 86.87L60.84 86.88Z"
        fill="url(#paint7_linear_1_2)"
      />
      <path
        d="M34.29 107.01C34.5 106.31 34.71 105.62 34.93 104.92C37.03 97.93 39.88 91.17 42.84 84.45C44.57 80.25 46.85 75.94 47.38 71.29C47.66 69.23 48.3 65.42 48.36 62.57C48.39 59 47.79 55.47 47.45 51.92C47.15 48.11 46.56 44.33 46.17 40.54C46.16 40.43 46.2 40.3 46.11 40.21C46 40.11 45.78 40.18 45.79 40.33C46.54 46.06 47.09 51.83 47.17 57.61C47.17 61.11 47.33 65.18 46.87 68.39C46.67 70.03 46.14 71.21 45.61 72.67C45.3 73.85 43.81 78.07 43.24 79.13C41.11 85.13 37.82 90.54 35.64 96.91C34.11 100.98 32.63 105.06 31.3 109.19C31.12 109.73 30.97 110.28 30.83 110.83C31.91 109.46 33.14 108.17 34.27 107.01H34.29Z"
        fill="url(#paint8_linear_1_2)"
      />
      <path
        d="M48.23 46.75C48.2 46.23 48.09 45.72 48.12 45.2C48.12 44.87 48.21 44.49 48.04 44.2C47.85 44.02 47.49 44.2 47.57 44.45C48.59 48.32 48.73 52.71 48.88 56.84C48.9 60.53 49.06 65.3 48.63 68.46C48.16 72.03 46.76 75.4 45.92 78.89C45.13 82.82 43.18 86.4 41.77 90.2C41.36 91.37 40.91 92.54 40.59 93.74C40.57 93.81 40.62 93.89 40.69 93.9C40.77 93.92 40.86 93.87 40.88 93.8C41.26 93.04 41.58 92.27 41.92 91.49C42.79 89.46 43.68 87.67 44.53 85.59C45.24 83.6 45.83 81.51 46.73 79.69C47.75 77.78 49.35 73.71 49.76 70.62C50.4 62.64 49.08 54.67 48.23 46.74V46.75Z"
        fill="url(#paint9_linear_1_2)"
      />
      <path
        d="M61.9 56.08C61.8 55.83 61.36 55.91 61.37 56.18C61.47 56.52 61.09 57.4 61.7 57.35C61.82 57.32 61.9 57.22 61.9 57.11C61.9 56.77 61.96 56.41 61.9 56.08Z"
        fill="url(#paint10_linear_1_2)"
      />
      <path
        d="M59.98 86.98C60.01 86.22 60.04 85.46 60.09 84.7C60.36 79.59 60.59 74.49 60.65 69.38C60.84 66.54 61.15 63.7 61.26 60.86C61.26 60.74 61.03 60.72 61.03 60.86C59.87 69.94 58.88 78 58.08 87.08C58.08 87.19 58.06 87.31 58.05 87.42C58.69 87.23 59.34 87.08 59.99 86.98H59.98Z"
        fill="url(#paint11_linear_1_2)"
      />
      <path
        d="M42.75 98.35C44.71 91.87 47.31 85.55 49.27 79.08C50.21 76.67 51.27 73.28 51.5 70.82C51.84 67.58 51.59 64.17 51.5 61.17C51.35 59.2 51.39 57.19 51.05 55.24C50.92 55.04 50.56 55.17 50.63 55.4C51.18 57.31 51.09 60.53 51.04 62.08C50.92 63.98 50.91 65.92 50.64 67.82C50.54 69.06 50.53 71.37 50.12 72.85C49.63 75.13 48.59 77.28 47.9 79.51C47.88 79.63 47.88 79.68 47.9 79.55C47.84 79.74 47.92 79.97 48.1 80.08C48.1 80.08 48.1 80.08 48.11 80.08C47.91 80.6 47.71 81.12 47.51 81.65C47.46 81.69 47.42 81.73 47.41 81.79C46.9 83.13 46.4 84.48 45.9 85.83C45.87 85.94 45.83 86.05 45.79 86.17C45.71 86.38 45.63 86.59 45.55 86.81C45.39 87.21 45.22 87.61 45.11 88.02C44.33 90.15 43.58 92.3 42.91 94.47C42.35 96.3 41.57 98.11 41.13 99.97C41.66 99.43 42.2 98.89 42.74 98.36L42.75 98.35Z"
        fill="url(#paint12_linear_1_2)"
      />
      <path
        d="M57.69 87.53C57.98 83.04 58.09 78.54 58.51 74.06C58.84 70.98 59.01 67.79 59.42 64.8C59.46 64.52 59.57 64.36 59.55 64.02C59.43 63.62 58.72 63.69 58.73 64.12C59.08 67 58.27 70.63 57.94 73.64C57.43 78.28 57.06 82.82 56.37 86.87C56.32 87.27 56.27 87.68 56.22 88.08C56.7 87.88 57.19 87.7 57.69 87.54V87.53Z"
        fill="url(#paint13_linear_1_2)"
      />
      <path
        d="M53.71 89.3C54.27 88.98 54.85 88.69 55.44 88.42C55.53 86.89 55.62 85.36 55.7 83.82C55.84 79.62 56.39 75.45 56.85 71.27C56.87 70.89 57.07 69.71 56.89 70.08C57.13 69.55 57.17 68.67 57.22 68.24C57.11 67.86 56.43 67.92 56.44 68.33C56.76 74.28 54.71 83.36 53.71 89.31V89.3Z"
        fill="url(#paint14_linear_1_2)"
      />
      <path
        d="M35.9 105.37C36.64 104.6 37.37 103.84 38.09 103.09C38.42 101.56 38.75 100.03 39.14 98.51C39.36 97.58 39.68 96.65 39.9 95.73C39.87 95.43 39.35 95.39 39.27 95.69C38.12 98.66 36.67 102.37 35.65 105.61C35.73 105.53 35.81 105.45 35.88 105.37H35.9Z"
        fill="url(#paint15_linear_1_2)"
      />
      <path
        d="M44.17 96.98C44.74 96.44 45.32 95.9 45.91 95.36C46.31 93.88 46.7 92.4 47.14 90.92C48.38 86.74 49.83 82.6 50.9 78.38C52.08 74 52.83 69.54 52.67 65.02C52.65 64.9 52.7 64.76 52.6 64.67C52.48 64.56 52.24 64.64 52.25 64.8C52.61 70.49 51.32 75.96 49.12 81.29C47.32 86.47 45.45 91.66 44.18 96.97L44.17 96.98Z"
        fill="url(#paint16_linear_1_2)"
      />
      <path
        d="M52.4 90.09C52.6 87.8 52.82 85.5 53.15 83.48C53.65 79.92 54.48 76.13 54.99 72.49C55.11 72.15 54.62 71.88 54.5 72.32C53.86 78.55 52.31 84.93 50.81 91.19C51.31 90.82 51.84 90.45 52.4 90.09Z"
        fill="url(#paint17_linear_1_2)"
      />
      <path
        d="M49.15 92.54C49.21 92.19 49.26 91.84 49.32 91.49C50.07 86.98 50.93 82.48 52 78.02C52.06 77.62 52.27 77.18 52.21 76.79C52.16 76.75 52.08 76.78 52.06 76.83C50.69 82.5 47.58 89.85 46.46 94.86C47.33 94.08 48.23 93.31 49.15 92.54Z"
        fill="url(#paint18_linear_1_2)"
      />
      <path
        d="M136.1 56.11C134.79 55.96 133.41 56.32 132.14 56.6C126.7 57.95 121.52 60.53 117.98 64.57C117.47 65.18 117 65.81 116.55 66.47C117.89 63.87 119.81 61.5 122.29 59.63C122.89 59.2 123.94 58.6 124.7 58.17C125.21 57.93 125.73 57.7 126.25 57.5C126.34 57.45 126.4 57.36 126.4 57.27C126.4 57.1 126.2 56.96 126.02 57.01C120.38 58.91 115.62 63.64 113.85 68.6C112.54 71.81 112 75.39 112.74 78.76C112.74 78.76 112.74 78.78 112.74 78.79C112.69 81.08 113.21 83.69 114.1 85.26C114.33 85.64 114.6 86.07 115.05 86.25C116.1 86.58 116.5 85.6 116.11 84.85C116.2 84.79 116.29 84.72 116.39 84.67C116.39 84.63 116.38 84.59 116.37 84.56C116.58 84.33 116.74 84.13 116.87 83.59C116.89 83.51 116.89 83.42 116.89 83.34C117.09 83.52 117.4 83.59 117.68 83.44C117.99 83.25 118.93 82.08 119.43 81C119.76 80.34 120.03 79.37 120.23 78.81C120.48 78.51 120.21 78.18 119.93 78.45C119.38 79.2 118.57 80.12 117.87 81.01C117.89 80.59 117.96 80.11 118.13 79.51C118.3 78.8 118.49 78.42 119.04 77.73C119.16 77.59 119.28 77.46 119.41 77.34C119.53 77.2 119.79 77.12 119.83 76.94C119.83 76.82 119.68 76.74 119.56 76.8C118.26 77.59 116.87 78.8 116.45 80.32C116.38 80.54 116.36 80.8 116.36 81.06C116.29 80.98 116.23 80.89 116.13 80.83C115.83 80.66 115.46 80.72 115.2 80.9C115.18 80.84 115.16 80.78 115.14 80.72C115.09 80.49 115.05 80.26 115.01 80.03C114.87 78.79 114.83 77.7 114.81 77.03C114.81 77.03 114.81 77.02 114.81 77.01C114.94 77.01 115.09 77.01 115.27 76.94C115.34 76.9 115.4 76.85 115.46 76.79L115.48 76.77C115.53 76.71 115.64 76.56 115.73 76.44C115.79 76.36 115.82 76.32 115.83 76.29C116.66 75.45 116.67 75.39 117.97 74.73C118.95 74.29 120.05 73.99 121.63 73.75C121.8 73.73 121.96 73.71 122.13 73.71C122.26 73.7 122.41 73.75 122.53 73.69C122.59 73.64 122.55 73.54 122.46 73.55C120.24 73.31 117.81 73.52 116.19 74.22C115.66 74.46 115.16 74.81 114.77 75.23C114.77 75.17 114.77 75.1 114.78 75.04C114.84 74.79 114.9 74.53 114.96 74.25C115.08 73.74 115.11 73.64 115.15 73.46C115.25 73.79 115.73 74.03 116.1 73.76C117.45 73.15 119.16 72.84 120.86 72.8C121.99 72.75 123.12 72.75 124.25 72.79C124.39 72.79 124.4 72.58 124.25 72.58C122.02 72.41 118.62 72.01 116.87 72.31C116.21 72.43 115.37 72.83 115.25 73.03C115.22 73.06 115.21 73.1 115.19 73.13C115.19 73.06 115.21 72.98 115.22 72.88C115.23 72.82 115.22 72.76 115.21 72.71C115.21 72.68 115.2 72.65 115.18 72.62C115.34 72.13 115.52 71.64 115.71 71.16C115.72 71.35 115.87 71.54 116.14 71.54C116.9 71.61 119.03 71.63 120.26 71.66C120.51 71.66 121.7 71.7 122.29 71.68C122.51 71.61 122.44 71.28 122.2 71.29C120.46 71.07 117.88 70.63 116.14 70.72C116.02 70.72 115.93 70.76 115.86 70.81C116 70.47 116.14 70.14 116.29 69.8C116.32 69.9 116.38 69.99 116.49 70.04C116.71 70.14 116.95 70.13 117.46 70.16C121.12 70.48 125.18 70.74 129.28 71.09C130.3 71.18 131.16 71.3 132.19 71.47C132.35 71.51 132.43 71.28 132.26 71.24C126.25 70.3 123.06 69.48 118.61 69.21C117.9 69.21 116.84 69.13 116.55 69.25C118.08 66.16 120.3 63.29 123.16 61.08C125.27 59.67 127.42 58.63 129.78 57.97C131.45 57.5 133.61 57.16 134.77 57.01C135.2 56.96 136 56.88 135.86 56.89C136.04 56.89 136.23 56.79 136.29 56.63C136.39 56.45 136.29 56.2 136.1 56.1V56.11Z"
        fill="url(#paint19_linear_1_2)"
      />
      <path
        d="M129.77 55.72C129.52 55.78 129.24 55.78 129.02 55.89C128.81 56.02 128.88 56.34 129.13 56.4C129.4 56.39 129.97 56.34 130.14 56.14C130.29 55.93 130.04 55.64 129.78 55.71L129.77 55.72Z"
        fill="url(#paint20_linear_1_2)"
      />
      <path
        d="M133.04 49.59C132.12 49.57 131.2 49.55 130.28 49.6C128.15 49.71 126.04 50.12 124.04 50.78C119.11 52.63 114.46 54.49 111.09 58.04C108.97 60.25 107.68 62.98 106.42 65.65C104.4 70.1 103.12 74.58 103 79.23C102.93 81.66 103.31 84.07 103.93 86.43C103.03 84 102.6 81.45 102.58 78.52C102.53 75.18 102.66 72.26 103.39 69.35C104.16 66.66 105.24 63.98 106.46 61.49C106.74 60.91 107.17 60.36 107.38 59.76C107.35 59.66 107.19 59.64 107.14 59.73C101.1 69.66 98.22 82.1 103.16 91.88C100.77 87.33 99.58 83.33 99.56 77.57C99.72 73.96 100.5 70.45 101.88 66.98C102.01 66.62 102.2 66.27 102.35 65.91C102.34 65.87 102.26 65.86 102.24 65.9C98.69 73.94 96.89 82.88 100 91.29C100.56 92.78 101.41 94.66 101.88 95.64C102.69 95.1 103.53 94.59 104.39 94.1C104.15 93.7 103.91 93.28 103.7 92.89C103.93 93.29 104.18 93.69 104.43 94.08C104.59 93.99 104.75 93.89 104.92 93.8C105.77 93.17 106.62 92.53 107.47 91.9C105.74 89.98 104.9 87.2 104.57 84.2C105.14 86.85 106.23 89.4 107.61 91.79C108.33 91.26 109.04 90.73 109.75 90.19C109.51 89.87 109.29 89.55 109.07 89.24C109.39 89.55 109.76 89.67 110.18 89.45C110.23 89.55 110.28 89.65 110.34 89.74C110.81 89.38 111.28 89.03 111.75 88.66C112.17 88.33 112.56 87.98 112.95 87.61C112.87 87.45 112.78 87.3 112.7 87.14C112.33 86.35 112 85.41 111.72 84.38C112 85.09 112.3 85.79 112.64 86.49C112.7 86.59 112.8 86.65 112.92 86.68C113.25 86.77 113.6 86.46 113.5 86.16C112.09 81.86 111.67 76.51 112.38 72.61C112.92 69.94 113.42 67.57 114.96 65.39C116.08 63.9 117.67 62.27 119.63 60.51C122.38 58.36 124.78 56.64 128.39 55.28C129.64 54.9 130.88 54.65 132.13 54.5C132.06 54.28 132.15 54 132.4 53.86C132.24 53.82 132.09 53.76 131.93 53.66C131.53 53.68 131.14 53.7 130.74 53.74C128.27 53.92 125.58 54.74 123.19 55.91C122.07 56.4 118.74 58.31 117.39 59.86C115.71 61.65 114.7 63.37 113.5 65.87C112.84 67.26 112.05 68.94 111.54 70.67C111.39 71.15 111.26 71.64 111.13 72.12C111.35 70.07 111.56 68.71 112.53 65.83C113.96 62.74 117.12 58.24 120.77 56.06C122.75 54.81 124.79 53.74 127.15 53.34C127.27 53.31 127.42 53.33 127.49 53.22C127.58 53.09 127.43 52.89 127.26 52.94C123.39 53.64 119.85 55.82 116.91 58.04C111.73 62.25 108.83 67.69 107.87 73.46C108.11 71.59 108.56 69.73 109.28 68.02C111.46 62.76 115.57 57.19 121.17 53.89C121.95 53.44 122.82 53.12 123.66 52.8C123.7 52.74 123.63 52.66 123.56 52.68C118.16 54.64 114.19 58.79 111.04 63.07C110.03 64.47 109.17 65.93 108.46 67.43C108.56 67.18 108.66 66.93 108.76 66.67C109.83 63.9 111.35 61.1 113.64 58.35C114.51 57.45 115.51 56.67 116.51 55.9C116.56 55.81 116.41 55.71 116.34 55.79C111.07 59.78 107.45 64.77 105.63 69.99C106.28 67.53 107.28 64.99 108.79 62.9C109.93 61.22 111.11 60.13 112.78 58.46C115.27 56.1 117.11 54.56 120.33 52.96C124.72 50.81 129.37 50.47 133.61 50C133.74 49.98 133.89 50.01 134 49.92C134.31 49.43 133.32 49.62 133.04 49.56V49.59ZM106.01 74.6C106.32 73.16 106.72 71.92 107.18 70.67C105.56 75.71 105.59 81.07 107.54 86.26C107.7 86.6 107.88 87.09 108.1 87.58C106 83.7 105.47 78.92 106.01 74.6Z"
        fill="url(#paint21_linear_1_2)"
      />
      <path
        d="M112.5 54.65C111.47 55.32 110.4 55.95 109.65 56.9C109.64 56.88 109.54 57.1 109.7 57.16C109.77 57.2 109.88 57.19 109.94 57.13C110.25 56.86 110.54 56.56 110.86 56.29C111.44 55.78 111.93 55.18 112.6 54.76C112.67 54.7 112.58 54.6 112.5 54.65Z"
        fill="url(#paint22_linear_1_2)"
      />
      <path
        d="M82.81 41.76C81.7 43.35 80.7 45 79.83 46.71C79.69 47.13 79.04 47.9 79.13 48.24C79.2 48.31 79.34 48.28 79.37 48.18C80.19 45.89 82.04 43.87 83.08 41.74C83.02 41.66 82.87 41.67 82.81 41.75V41.76Z"
        fill="url(#paint23_linear_1_2)"
      />
      <path
        d="M118.19 21.35C112.13 21.21 106.77 23.08 101.55 25.77C97.75 27.68 94.2 29.98 91.02 32.66C88.9 34.43 86.8 36.24 84.92 38.22C84.81 38.32 84.98 38.49 85.1 38.38C93.47 29.76 104.43 24.23 116.74 21.99C117.59 21.8 118.49 21.74 119.34 21.56C119.6 21.24 118.39 21.4 118.19 21.34V21.35Z"
        fill="url(#paint24_linear_1_2)"
      />
      <path
        d="M99.91 97.01C100.35 96.69 100.8 96.37 101.26 96.06C100.8 95.23 100.39 94.44 100.11 93.76C98.15 88.9 97.59 85.28 97.52 80.18C97.56 78.06 97.95 76.06 98.54 74C98.56 73.87 98.67 73.74 98.62 73.61C98.56 73.52 98.39 73.53 98.36 73.64C96.81 79.31 95.97 85.83 97.44 90.99C97.95 93.09 98.87 95.07 99.91 97V97.01Z"
        fill="url(#paint25_linear_1_2)"
      />
      <path
        d="M77.95 50.18C77.64 50.66 77.38 51.18 77.14 51.69C77.12 51.78 77.25 51.86 77.33 51.81C77.66 51.32 77.91 50.76 78.24 50.27C78.27 50.12 78.03 50.05 77.95 50.18Z"
        fill="url(#paint26_linear_1_2)"
      />
      <path
        d="M85.24 40.3C85.68 39.75 86.12 39.2 86.6 38.67C86.13 39.2 85.68 39.74 85.24 40.3Z"
        fill="url(#paint27_linear_1_2)"
      />
      <path
        d="M86.94 107.52C81.16 100.07 78.29 90.75 76.92 81.2C76.05 76.07 75.68 69.58 76.63 64.1C77.04 61.61 77.66 59.15 78.45 56.73C78.67 56 78.94 55.29 79.16 54.56C79.16 54.5 79.04 54.49 79.02 54.56C75.28 63.17 74.72 72.57 75.82 81.69C76.38 90.73 79.27 99.74 84.76 107.31C83.75 106.13 82.81 104.89 81.75 103.42C76.63 96.25 75.46 87.94 74.66 79.97C73.89 70.45 74.88 61.92 78.42 53.06C80.09 48.59 82.23 44.14 85.23 40.3C80.98 45.58 78.19 51.75 76.1 57.95C75.1 60.95 74.08 63.96 73.65 67.08C73.1 70.5 73.18 73.96 73.21 77.4C73.34 87.45 75.03 98.05 81.87 106.3C82.76 107.46 83.72 108.58 84.73 109.66C84.08 109.1 83.45 108.53 82.92 108.01C76.9 102.32 73.88 92.88 72.78 85.25C71.59 79.03 71.82 71.11 73.16 64.53C73.67 61.41 74.37 58.29 75.42 55.28C75.65 54.67 75.95 54.07 76.2 53.47C76.19 53.42 76.11 53.42 76.1 53.47C72.87 60.7 71.51 68.5 71.04 76.25C70.4 88.06 73.18 101.1 82.56 109.83C79.14 107.81 76.51 104.83 74.55 101.47C72.66 98.01 71.55 93.76 70.57 89.72C69.94 87.09 69.6 85.01 69.34 82.44C69.25 81.96 69.37 81.81 69.13 81.53C68.55 81.17 68.25 81.66 68.36 82.22C68.42 83.3 68.55 84.37 68.7 85.44C70.11 94.02 72.59 103.4 80.36 109.15C81.19 109.78 82.49 110.5 83.63 110.93C83.68 110.93 83.71 110.93 83.75 110.91C83.96 111.08 84.16 111.25 84.35 111.42C84.99 109.99 85.88 108.71 86.93 107.53L86.94 107.52Z"
        fill="url(#paint28_linear_1_2)"
      />
      <path
        d="M80.68 50.61C80.43 51.14 80.2 51.68 80 52.23C80 52.26 80.04 52.27 80.06 52.25C80.3 51.73 80.55 51.19 80.84 50.66C80.86 50.58 80.73 50.54 80.69 50.61H80.68Z"
        fill="url(#paint29_linear_1_2)"
      />
      <path
        d="M87.35 107.07C87.72 106.67 88.12 106.29 88.52 105.91C87.79 104.98 87.08 104 86.37 102.92C84.15 98.99 82.92 95.98 81.34 92.09C79.63 87.06 78.33 81.76 77.67 76.7C77.39 74.31 77.21 71.91 77.22 69.51C77.19 68.66 77.26 67.79 77.22 66.95C77.18 66.91 77.1 66.95 77.1 66.99C76.89 75.25 77.44 83.59 79.68 91.62C80.77 95.4 82.5 99.02 84.28 102.58C85.17 104.14 86.21 105.63 87.35 107.06V107.07Z"
        fill="url(#paint30_linear_1_2)"
      />
      <path
        d="M97.47 98.07C97.56 98.25 97.66 98.44 97.76 98.63C98.2 98.29 98.65 97.96 99.09 97.63C98.62 96.67 98.2 95.68 97.85 94.63C96.98 92.16 96.06 89.68 95.68 87.1C95.44 85.64 95.36 83.38 95.35 81.52C95.31 80.96 95.39 80.38 95.34 79.82C95.3 79.78 95.21 79.81 95.21 79.87C95.04 83.34 94.62 86.83 95.14 90.29C95.46 92.46 96.34 95.57 97.47 98.08V98.07Z"
        fill="url(#paint31_linear_1_2)"
      />
      <path
        d="M89.25 105.25C89.66 104.89 90.08 104.54 90.51 104.19C88.02 100.62 86.22 97.37 84.92 93.4C83.06 88.45 81.29 83.45 80.26 78.29C79.88 76.34 79.42 74.48 79.57 72.49C79.55 72.23 79.71 71.84 79.62 71.66C79.57 71.62 79.48 71.65 79.47 71.71C79.08 74.19 79.56 76.69 79.83 79.16C80.54 85.3 82.33 91.54 84.84 97.81C86.03 100.41 87.55 102.89 89.24 105.26L89.25 105.25Z"
        fill="url(#paint32_linear_1_2)"
      />
      <path
        d="M95.56 100.32C95.96 100.01 96.35 99.71 96.74 99.4C95.9 97.73 95.21 96.01 94.61 93.91C94.03 91.9 93.57 89.68 93.3 87.79C93.18 87.04 93.12 86.28 92.96 85.55C92.91 85.49 92.79 85.52 92.8 85.6C93.24 89.47 93.26 92.85 94.28 96.48C94.54 97.7 95 99.02 95.56 100.31V100.32Z"
        fill="url(#paint33_linear_1_2)"
      />
      <path
        d="M95.21 100.59C95.21 100.59 95.27 100.55 95.29 100.52C94.02 98.95 92.74 97.2 91.68 95.18C91.5 94.89 91.47 94.4 91.27 94.17C91.13 94.09 90.94 94.22 90.99 94.36C91.73 96.77 92.9 99.06 94.34 101.25C94.63 101.03 94.92 100.81 95.21 100.59Z"
        fill="url(#paint34_linear_1_2)"
      />
      <path
        d="M89.74 101.61C90.16 102.33 90.62 103.03 91.1 103.72C91.51 103.4 91.93 103.08 92.34 102.76C89.89 99.3 87.68 95.63 86.28 92.2C85.68 90.54 85.32 88.87 85.17 87.18C85.17 87.03 84.89 87.01 84.9 87.18C85.18 89.34 85.52 91.51 86.14 93.61C87.08 96.66 88.28 99.03 89.74 101.61Z"
        fill="url(#paint35_linear_1_2)"
      />
      <path
        d="M92.8 102.41C93.19 102.12 93.58 101.82 93.96 101.53C92.42 99.34 90.85 96.9 89.88 94.98C89.59 94.34 89.18 93.41 88.95 92.44C88.89 92.25 88.9 91.76 88.72 92C89.16 95.51 90.3 98.08 91.9 100.95C92.21 101.45 92.5 101.94 92.79 102.41H92.8Z"
        fill="url(#paint36_linear_1_2)"
      />
      <path
        d="M130.12 23.06C129.02 22.91 127.91 22.81 126.79 22.74C116.01 22.03 105.13 25.21 96.17 30.58C93.83 32.21 91.57 33.95 89.57 35.93C89.26 36.26 88.84 36.55 88.63 36.93C88.64 36.98 88.72 37 88.76 36.96C91.27 34.36 94.43 32.76 97.62 30.82C103 27.65 108.49 25.71 114.72 24.3C118.69 23.39 122.52 22.76 126.61 22.96C127.8 23 129 23.19 130.17 23.2C130.22 23.16 130.18 23.07 130.11 23.07L130.12 23.06Z"
        fill="url(#paint37_linear_1_2)"
      />
      <path
        d="M116.94 24.52C106.35 26.28 96.48 30.45 89.27 37.9C86.87 40.28 84.76 42.89 83.18 45.78C83.08 46.06 82.88 46.33 82.79 46.61C82.8 46.66 82.89 46.67 82.91 46.62C88.9 36.15 103.47 27.45 116.39 25.08C118.29 24.76 120.16 24.52 122.09 24.43C122.76 24.36 123.51 24.48 124.14 24.3C125.07 23.28 117.51 24.45 116.93 24.51L116.94 24.52Z"
        fill="url(#paint38_linear_1_2)"
      />
      <path
        d="M117.33 26.22C117.2 26.21 117.08 26.25 116.95 26.25C114.48 26.57 112.03 27.09 109.62 27.69C103.41 29.13 97.96 32.6 93.42 36.6C87.51 41.7 83.48 47.75 80.54 54.47C79.21 57.56 78.14 60.79 77.75 64.1C77.75 64.29 77.7 64.51 77.8 64.68C77.89 64.77 78.07 64.7 78.06 64.58C78.88 57.66 82.54 51.06 86.69 45.42C91.82 38.86 99.51 32.32 107.55 29.31C109.23 28.63 112.04 27.71 114.3 27.2C115.32 26.9 116.47 26.83 117.45 26.48C117.51 26.39 117.45 26.25 117.33 26.22Z"
        fill="url(#paint39_linear_1_2)"
      />
      <path
        d="M108.65 30.43C106.18 31.23 103.93 32.17 101.67 33.39C96.92 35.9 92.9 39.12 89.49 43.28C85.75 47.43 82.97 52.18 81.16 57.26C79.92 60.56 79.28 64.15 79.61 67.61C79.68 67.89 79.65 68.2 79.75 68.47C79.82 68.54 79.95 68.49 79.95 68.4C79.72 64.78 80.73 60.81 82.2 57.11C85.32 48.54 92.08 40.51 100.04 35.25C102.72 33.38 105.9 31.84 108.88 30.77C109.09 30.64 108.88 30.31 108.63 30.44L108.65 30.43Z"
        fill="url(#paint40_linear_1_2)"
      />
      <path
        d="M99.59 36.89C97.66 38.52 95.56 39.82 93.74 41.58C88.45 46.57 84.82 52.82 82.8 59.44C82.72 59.7 82.52 60.18 82.9 60.03C83.01 59.83 83.05 59.6 83.13 59.39C85.13 52.86 89.43 47.29 94.29 42.44C95.53 41.15 96.76 39.85 98.11 38.65C98.7 38.11 99.4 37.67 99.99 37.15C100.1 36.94 99.77 36.72 99.58 36.9L99.59 36.89Z"
        fill="url(#paint41_linear_1_2)"
      />
      <path
        d="M98.68 41.43C95.01 43.02 91.99 46.21 90.02 49.67C89.59 50.39 89.13 51.1 88.76 51.85C88.69 51.95 88.74 52.1 88.87 52.14C88.99 52.19 89.14 52.12 89.17 52.01C89.89 50.37 91.39 48.53 92.62 47.06C93.02 46.61 93.87 45.58 94.67 44.84C95.56 43.99 96.98 43.03 97.64 42.57C97.94 42.35 98.49 41.99 98.8 41.79C98.98 41.7 98.9 41.44 98.7 41.44L98.68 41.43Z"
        fill="url(#paint42_linear_1_2)"
      />
      <path
        d="M136.85 50.56C143.82 50.61 150.7 53.07 155.52 56.96C157.81 58.83 159.23 60.99 160.13 62.53C161.18 62.43 162.23 62.35 163.27 62.28C161.54 59.55 158.83 57.49 156.1 55.66C151.38 52.43 145.98 50.72 140.16 50.42C139.04 50.35 137.9 50.25 136.78 50.28C136.62 50.34 136.66 50.57 136.84 50.57L136.85 50.56Z"
        fill="url(#paint43_linear_1_2)"
      />
      <path
        d="M153.54 63.38C155.71 63.02 157.91 62.74 160.11 62.53C155.74 56 148.8 52.49 140.35 51.78C138.38 51.56 135.21 51.49 132.61 51.75C132.1 51.79 131.59 51.82 131.09 51.87C130.89 51.94 130.95 52.23 131.17 52.23C135.61 51.48 139.43 52.21 143.57 53.32C148.37 54.5 152.98 56.9 156.15 60.18C154.58 58.93 152.78 57.88 150.82 57.16C147.87 55.54 144.53 54.7 140.99 54.56C139.05 54.48 137.1 54.56 135.18 54.81C134.89 54.89 134.33 54.77 134.16 55.02C134.12 55.15 134.26 55.27 134.4 55.24C137.44 54.61 140.1 54.92 142.96 55.61C145.75 56.21 148.03 57.14 150.78 58.86C152.09 59.67 153.52 60.93 154.72 62.33C152.72 60.35 149.85 58.41 147.27 57.44C145.54 56.76 143.65 56.45 141.8 56.16C141.39 56.1 136.29 55.42 137.65 56.26C141.53 56.17 146.03 57.47 148.53 59.38C149.91 60.28 152.05 61.87 153.53 63.4L153.54 63.38Z"
        fill="url(#paint44_linear_1_2)"
      />
      <path
        d="M163.97 62.23C164.81 62.18 165.64 62.14 166.48 62.11C167.07 62.09 167.65 62.06 168.23 62.02C168.91 61.85 169.58 61.68 170.26 61.53C168.2 58.58 165.45 56.18 162.14 53.6C158.53 50.58 154.03 48.68 149.13 47.33C145.01 46.22 140.68 45.75 136.39 45.86C136.21 45.88 136.01 45.81 135.86 45.91C135.74 46.01 135.83 46.21 136 46.21C143.13 45.89 150.06 47.63 156.13 50.85C159.26 52.5 161.55 54.81 164.14 57.67C164.45 58.03 164.79 58.43 165.14 58.86C162.32 55.83 158.49 53.22 154.31 51.23C150.24 49.12 145.71 47.87 141.04 47.53C134.45 46.91 128.33 48.04 121.95 50.17C119.68 50.92 117.47 51.81 115.35 52.87C115.24 52.93 115.34 53.1 115.46 53.04C120.34 51.03 125.98 49.29 130.92 48.89C133.74 48.63 136.53 48.6 139.25 48.8C138.75 48.8 138.21 48.71 137.74 48.84C137.63 48.93 137.71 49.11 137.86 49.11C145.91 49.11 153.58 52.32 159.22 56.91C161.44 58.95 162.57 60.03 163.97 62.23Z"
        fill="url(#paint45_linear_1_2)"
      />
      <path
        d="M133.07 46.6C132.94 46.46 132.88 46.53 132.73 46.53C131.06 46.67 128.94 47.01 127.15 47.39C127 47.44 126.8 47.41 126.71 47.54C126.61 47.68 126.77 47.87 126.95 47.82C128.9 47.41 130.91 47.25 132.87 46.87C133.02 46.87 133.16 46.74 133.07 46.6Z"
        fill="url(#paint46_linear_1_2)"
      />
      <path
        d="M176.73 47.23C178.1 49.05 179.39 51.37 180.43 53.42C178.3 50.13 176.13 46.83 173.39 43.91C171.96 42.32 170.21 41 168.53 39.62C166.03 37.58 163.39 35.66 160.47 34.13C160.07 33.94 159.71 33.65 159.3 33.49C159.07 33.46 158.94 33.76 159.15 33.87C161.05 34.75 162.39 35.89 164.03 37.04C167.63 39.55 170.9 42.32 173.55 45.43C175.85 48.01 178.79 52.55 180.29 55.59C180.87 56.89 181.36 58.22 181.82 59.55C181.93 59.54 182.03 59.52 182.14 59.51C183.13 59.14 184.11 58.76 185.1 58.37C184.93 58.01 184.79 57.72 184.69 57.55C182.57 53.43 180 49.26 177.06 45.82C175.09 43.52 172.68 41.58 170.29 39.65C164.61 35.02 158.24 30.52 151.19 28.05C148.75 27.12 146.25 26.34 143.7 25.7C142.66 25.45 141.44 25.13 140.46 25.19C149.43 27.06 157.38 31.17 164.79 36.08C169.38 39.1 173.76 43.14 176.76 47.23H176.73Z"
        fill="url(#paint47_linear_1_2)"
      />
      <path
        d="M155.39 31.24C154.7 30.92 153.97 30.66 153.24 30.45C153.19 30.45 153.17 30.53 153.22 30.55C154.12 30.9 154.96 31.44 155.88 31.71C156.24 31.48 155.57 31.34 155.39 31.23V31.24Z"
        fill="url(#paint48_linear_1_2)"
      />
      <path
        d="M144.99 44.64C144.93 44.69 144.97 44.8 145.06 44.79C145.2 44.78 145.5 44.91 145.49 44.71C145.46 44.61 145.07 44.59 144.99 44.64Z"
        fill="url(#paint49_linear_1_2)"
      />
      <path
        d="M173.09 56.67C172.78 56.28 172.6 55.74 172.18 55.46C171.93 55.39 171.69 55.66 171.83 55.87C173 57.49 173.82 59.04 174.53 60.66C174.8 60.61 175.07 60.55 175.34 60.51C174.64 59.21 173.84 57.94 173.09 56.68V56.67Z"
        fill="url(#paint50_linear_1_2)"
      />
      <path
        d="M175.84 51.7C176.95 53.56 177.72 55.64 178.42 57.89C177.81 56.67 177.18 55.54 176.64 54.65C174.89 51.79 172.83 49.36 170.61 46.87C170.32 46.55 170.05 46.21 169.73 45.9C169.68 45.85 169.6 45.84 169.53 45.87C169.41 45.91 169.38 46.06 169.47 46.13C171.92 48.35 173.56 51.09 174.65 53.88C175.25 55.68 175.69 57.13 176.24 58.82C175.58 57.58 174.53 56.01 173.76 54.9C172.85 53.62 172.12 52.17 170.97 51.06C170.71 50.95 170.45 51.28 170.67 51.47C172.54 53.61 173.87 56.12 174.82 58.56C175.06 59.2 175.25 59.85 175.42 60.5C177.42 60.14 179.42 59.86 181.42 59.61C181.36 59.46 181.3 59.3 181.24 59.15C179.15 54.04 175.87 49.47 171.89 45.51C170.4 43.94 168.79 42.47 167.11 41.06C166.92 40.97 166.74 40.85 166.55 40.77C166.53 40.77 166.52 40.81 166.54 40.82C170.17 43.97 173.73 47.49 175.84 51.73V51.7Z"
        fill="url(#paint51_linear_1_2)"
      />
      <path
        d="M169.7 59.45C170.15 59.99 170.62 60.64 171.1 61.34C172.12 61.12 173.14 60.92 174.16 60.72C173.83 60.33 173.5 59.96 173.21 59.6C172.18 58.42 169.89 55.8 168.57 54.62C167.09 53.27 165.45 52.07 163.81 50.87C162.96 50.29 162.18 49.59 161.22 49.16C160.97 49.12 160.84 49.45 161.07 49.56C164.27 51.08 167.48 54.48 168.97 56.26C170 57.45 171.09 58.79 172.17 60.19C168.64 56.44 164.4 53.24 159.93 50.43C157.72 49.08 155.42 47.83 152.97 46.87C151.62 46.33 150.1 45.9 148.83 45.42C148.64 45.37 148.44 45.22 148.25 45.31C148.06 45.41 148.1 45.68 148.31 45.73C152.85 46.48 157.26 49.14 160.61 51.7C163.77 53.86 167.7 57.04 169.69 59.44L169.7 59.45Z"
        fill="url(#paint52_linear_1_2)"
      />
      <path
        d="M155.05 13.06C151.68 15.21 148.38 18.82 147.23 21.69C146.89 22.4 145.98 24.07 146.76 25.46C147.02 25.95 147.91 25.89 147.97 25.31C148.01 25.2 147.93 24.97 147.92 24.98C147.92 24.89 147.91 24.81 147.88 24.72C147.72 23.68 147.8 22.16 148.73 20.56C150.23 18.17 151.77 16.43 153.6 14.55C154 14.15 154.57 13.56 155.11 13.12C155.13 13.08 155.08 13.03 155.03 13.06H155.05Z"
        fill="url(#paint53_linear_1_2)"
      />
      <path
        d="M151.44 14.25C148.99 17.18 146.29 19.52 145.22 22.95C144.9 24.03 144.85 24.73 145.14 24.97C145.35 25.16 145.7 25.13 145.89 24.94C145.89 24.94 145.89 24.94 145.89 24.95C145.89 24.95 145.9 24.93 145.91 24.92C145.93 24.9 145.95 24.89 145.97 24.86C145.97 24.84 145.98 24.83 145.99 24.81C146.02 24.75 146.05 24.7 146.07 24.63C145.96 24.87 146.11 24.55 146.15 24.44C146.25 24.16 146.32 22.83 146.8 21.61C147.44 20.13 148.39 18.36 149.75 16.6C150.15 16.1 150.61 15.51 150.98 15.1C151.19 14.83 151.51 14.61 151.67 14.32C151.67 14.22 151.52 14.16 151.45 14.24L151.44 14.25Z"
        fill="url(#paint54_linear_1_2)"
      />
      <path
        d="M147.97 16.19C146.59 18.23 143.38 22.07 143.48 23.27C143.33 23.7 143.9 24.1 144.33 23.86C144.42 23.84 144.5 23.71 144.55 23.64C144.57 23.6 144.59 23.56 144.61 23.52C145.29 21.44 145.8 19.47 147.38 17.48C147.62 17.13 148.19 16.65 148.36 16.29C148.36 16.1 148.07 16.03 147.97 16.19Z"
        fill="url(#paint55_linear_1_2)"
      />
      <path
        d="M144.56 23.62C144.56 23.62 144.56 23.63 144.55 23.64C144.55 23.64 144.55 23.66 144.54 23.67C144.55 23.65 144.56 23.64 144.57 23.62H144.56Z"
        fill="url(#paint56_linear_1_2)"
      />
      <path
        d="M143.84 20.02C143.75 20.2 143.58 20.37 143.57 20.57C143.8 20.91 144.01 20.25 144.12 20.11C144.15 19.97 143.92 19.9 143.85 20.03L143.84 20.02Z"
        fill="url(#paint57_linear_1_2)"
      />
      <path
        d="M149.18 6.43999C145.2 8.52999 141.85 11.5 138.96 14.7C138.07 15.71 136.46 17.57 135.53 19.04C134.88 19.96 134.22 21.48 134.02 21.87C133.8 22.18 134.16 22.61 134.56 22.5C134.91 22.4 134.96 22.02 135.14 21.78C138.3 16.73 141.34 12.57 145.98 8.69999C147.01 7.86999 148.06 7.19999 149.27 6.57999C149.36 6.53999 149.28 6.39999 149.19 6.44999L149.18 6.43999Z"
        fill="url(#paint58_linear_1_2)"
      />
      <path
        d="M145.07 10.73C142.83 12.85 140.62 14.82 138.85 17.25C137.54 19.12 135.72 21.95 135.81 22.84C136.02 23.5 136.75 23.19 136.82 22.76C137.9 19.65 140.1 16.6 142.31 13.78C143.15 12.78 144.24 11.78 145.2 10.81C145.24 10.74 145.12 10.66 145.06 10.72L145.07 10.73Z"
        fill="url(#paint59_linear_1_2)"
      />
      <path
        d="M141.23 16.49C139.69 18.15 138.29 20.15 137.41 22.29C137.26 22.74 137.93 23.09 138.29 22.75C138.5 22.5 138.53 22.31 138.82 21.61C139.43 20.05 139.93 18.86 140.94 17.43C141.07 17.14 141.58 16.82 141.52 16.52C141.46 16.43 141.31 16.41 141.23 16.49Z"
        fill="url(#paint60_linear_1_2)"
      />
      <path
        d="M133.67 18.65C133.48 18.79 133.33 18.96 133.13 19.08C133.13 19.02 133.13 18.95 133.13 18.89C133.17 18.88 133.21 18.87 133.25 18.83C133.28 18.8 133.31 18.76 133.33 18.71C133.33 18.7 133.35 18.69 133.35 18.68C133.35 18.68 133.35 18.67 133.36 18.66C133.36 18.65 133.36 18.65 133.36 18.64C133.46 18.47 133.46 18.22 133.31 18.09C133.25 18.03 133.18 18 133.11 17.99C133.04 14.58 133.13 11.17 133.38 7.77001C133.59 6.00001 133.76 4.23001 133.91 2.45001C133.91 2.35001 133.96 2.23001 133.88 2.15001C133.78 2.06001 133.59 2.12001 133.59 2.26001C133.37 7.51001 132.35 12.33 132 17.39C131.91 15.88 131.82 14.36 131.84 11.91C131.99 9.38001 132.23 6.85001 132.53 4.32001C132.53 4.15001 132.22 4.13001 132.22 4.32001C131.83 10.92 130.73 16.24 130.62 21.07C130.72 21.67 130.51 21.55 130.88 22.06C130.99 22.16 131.12 22.21 131.24 22.23C131.47 22.36 131.79 22.36 131.99 22.16C132.02 22.14 132.04 22.12 132.06 22.11C132.45 21.92 132.72 21.52 133.04 21.26C133.69 20.72 134.42 19.94 134.59 19.69C134.73 19.49 134.8 19.62 134.87 19.14C134.89 18.59 134.1 18.28 133.66 18.64L133.67 18.65Z"
        fill="url(#paint61_linear_1_2)"
      />
      <path
        d="M133.67 18.64C133.7 18.62 133.74 18.59 133.77 18.57C133.74 18.59 133.71 18.61 133.67 18.64Z"
        fill="url(#paint62_linear_1_2)"
      />
      <path
        d="M133.63 18.67C133.63 18.67 133.66 18.65 133.67 18.64C133.65 18.65 133.64 18.66 133.63 18.67Z"
        fill="url(#paint63_linear_1_2)"
      />
      <path
        d="M128.95 20.9C128.95 20.9 128.92 20.84 128.93 20.81C128.96 20.95 128.96 20.96 128.95 20.9Z"
        fill="url(#paint64_linear_1_2)"
      />
      <path
        d="M130.53 6.38C130.46 6.32 130.34 6.36 130.34 6.45C130.16 9.61 129.75 12.78 129.37 15.62C129.17 17.08 128.98 18.39 128.87 20.06C128.83 20.24 128.93 20.77 128.95 20.9C129.01 21.12 129.26 21.27 129.51 21.21C129.59 21.19 129.65 21.15 129.7 21.1C129.86 21.04 129.98 20.9 129.95 20.68C129.95 20.63 129.93 20.59 129.92 20.56C129.92 20.56 129.92 20.55 129.92 20.54C130.15 18.46 130.06 16.81 130.12 14.84C130.14 12.12 130.36 9.4 130.55 6.69C130.55 6.59 130.6 6.47 130.53 6.39V6.38Z"
        fill="url(#paint65_linear_1_2)"
      />
      <path
        d="M124.04 20.18C124 18.61 123.92 17.05 123.83 15.48C123.67 11.48 123.98 7.47 123.83 3.47C123.79 3.3 123.87 3.04 123.7 2.93C123.63 2.91 123.55 2.97 123.55 3.04C123.52 7.03 123.61 11.04 123.27 15.02C123.16 16.05 123.05 17.19 122.98 18.33C122.81 16.02 122.66 12.53 122.52 9.34C122.45 7.2 122.57 5.05 122.63 2.9C122.62 2.76 122.69 2.61 122.58 2.5C122.47 2.4 122.25 2.47 122.25 2.62C122.41 8.15 121.64 13.61 121.51 18.33C121.45 16.85 121.44 15.37 121.28 13.9C121.14 12.76 120.93 11.53 120.77 9.31C120.59 7.35 120.9 5.38 120.75 3.41C120.73 3.34 120.74 3.24 120.67 3.19C120.61 3.16 120.53 3.21 120.55 3.28C120.91 7.28 119.99 12 119.82 14.12C119.71 15.8 119.79 17.49 119.88 19.17C119.78 19.17 119.69 19.16 119.58 19.15C119.62 18.99 119.66 18.83 119.67 18.67C119.69 17.99 119.68 17.3 119.61 16.61C119.52 16.19 119.5 16.01 119.53 15.46C119.53 15 119.59 14.59 119.65 14.15C119.61 14.03 119.4 14.05 119.4 14.18C119.29 15.34 118.97 16.24 118.71 17.07C118.24 18.63 117.86 19.01 117.28 20.31C117.28 20.34 117.28 20.35 117.27 20.37C117.27 20.39 117.27 20.41 117.26 20.43C117.25 20.49 117.25 20.51 117.26 20.5C117.25 20.67 117.29 20.84 117.41 20.96C117.61 21.23 118.02 21.29 118.33 21.16C118.52 21.29 118.75 21.35 119.02 21.28C119.78 21.2 120.56 21.41 121.3 21.25C121.39 21.22 121.48 21.19 121.54 21.15C121.57 21.14 121.6 21.13 121.63 21.11C121.63 21.11 121.63 21.12 121.63 21.13C121.66 21.22 121.69 21.31 121.72 21.37C121.74 21.42 121.76 21.45 121.79 21.49C121.79 21.5 121.81 21.51 121.81 21.52C122.12 21.89 122.88 21.84 123.04 21.35C123.04 21.33 123.05 21.32 123.06 21.3C123.08 21.33 123.09 21.35 123.12 21.37C123.37 21.6 123.82 21.55 124 21.27C124.17 20.93 124.03 20.54 124.05 20.18H124.04Z"
        fill="url(#paint66_linear_1_2)"
      />
      <path
        d="M185.02 107.23C189.75 106.32 195.16 102.17 198.74 98.63C199.64 97.77 200.57 96.95 201.49 96.12C201.68 95.95 201.39 95.66 201.19 95.85C196.62 100.65 191.56 104.16 185.11 105.89C185.62 104.18 186.11 102.46 186.54 100.72C187.37 97.43 187.72 94.07 188.05 90.72C188.11 90.13 188.14 89.54 188.17 88.94C188.15 88.72 188.27 88.45 188.09 88.27C187.89 88.08 187.5 88.22 187.51 88.49C187.47 91.45 186.7 94.34 185.99 97.4C185.28 99.93 184.51 102.45 183.71 104.97C184.19 105.7 184.59 106.49 185.03 107.23H185.02Z"
        fill="url(#paint67_linear_1_2)"
      />
      <path
        d="M211.49 110.03C205.89 108.53 199.94 108.43 194.15 108.85C193.49 108.93 192.92 109.02 192.37 109.11C192.79 108.89 193.19 108.65 193.58 108.4C193.77 108.2 193.62 107.93 193.39 107.85C194.47 107.28 195.49 106.6 196.52 105.97C198.76 104.55 200.64 103.44 202.6 101.61C204.09 100.26 205.65 98.94 206.95 97.45C207.02 97.23 206.66 97.08 206.53 97.29C204.59 99.94 201.69 101.68 199.23 103.25C195.65 105.64 192.53 107.09 188.81 108.18C189.73 107.74 190.66 107.25 191.45 106.78C194.08 105.4 196.67 103.93 198.97 102.11C199.92 101.34 200.97 100.65 201.83 99.79C201.88 99.69 201.73 99.59 201.64 99.67C197.03 103.84 191.27 106.47 185.61 108.22C186.04 108.91 186.52 109.61 187.07 110.19C187.14 110.26 187.2 110.32 187.27 110.39C187.13 110.65 187.19 111 187.51 111.15C188.03 111.31 187.81 111.21 188.26 111.17H188.23C188.28 111.16 188.34 111.14 188.39 111.14C188.41 111.14 188.42 111.17 188.44 111.17C188.52 111.19 188.6 111.18 188.68 111.17C188.43 111.2 188.12 111.22 187.91 111.46C187.89 111.48 187.86 111.49 187.84 111.51C187.84 111.51 187.84 111.51 187.83 111.52C187.83 111.52 187.82 111.53 187.81 111.54C187.81 111.54 187.8 111.56 187.79 111.56C187.63 111.75 187.69 112.02 187.89 112.15C187.91 112.17 187.95 112.19 188.01 112.21C188.23 112.35 188.53 112.38 188.79 112.34C190.22 112.12 191.79 111.99 194.05 111.72C195.7 111.51 196.96 111.29 198.7 111.34C199.54 111.37 200.44 111.43 201.19 111.55C201.46 111.66 201.59 111.48 201.4 111.39C200.07 111.18 198.72 111.23 197.37 111.19C195.59 111.12 193.79 111.03 191.93 111.05C190.94 111.04 189.94 111.11 188.95 111.14C192.72 110.57 196.35 109.9 200.48 109.97C202.43 110 204.47 110.02 206.32 110.32C206.45 110.36 206.52 110.16 206.38 110.13C202.02 109.6 197.6 109.64 193.21 109.93C193.26 109.92 193.32 109.91 193.38 109.89C196.3 109.2 199.04 109.08 202.17 109.1C205.15 109.13 208.15 109.4 211.03 110.1C211.19 110.12 211.35 110.24 211.51 110.21C211.59 110.17 211.58 110.04 211.48 110.02L211.49 110.03Z"
        fill="url(#paint68_linear_1_2)"
      />
      <path
        d="M182.95 103.98C183.13 104.18 183.3 104.4 183.46 104.61C184.72 100.5 185.76 96.33 186.43 92.28C186.43 92.07 186.63 91.61 186.48 91.4C186.37 91.3 186.15 91.35 186.12 91.49C185.2 95.57 184.01 99.72 182.62 103.65C182.73 103.76 182.85 103.87 182.95 103.99V103.98Z"
        fill="url(#paint69_linear_1_2)"
      />
      <path
        d="M182.02 103.05C183.4 98.62 184.31 94.08 184.94 89.52C184.94 89.37 185.11 88.82 185.07 88.56C185.01 88.47 184.84 88.48 184.81 88.59C184.23 92.33 183.25 96.01 181.8 99.56C181.51 100.34 181.19 101.16 180.87 101.99C181.26 102.35 181.64 102.7 182.02 103.06V103.05Z"
        fill="url(#paint70_linear_1_2)"
      />
      <path
        d="M180.11 101.26C180.25 101.4 180.39 101.53 180.54 101.67C181.53 98.9 182.35 96.08 182.92 93.21C183.07 92.38 183.25 91.56 183.41 90.74C183.39 90.57 183.1 90.54 183.05 90.72C182.13 94.46 180.86 97.68 179.51 100.72C179.71 100.9 179.91 101.08 180.11 101.27V101.26Z"
        fill="url(#paint71_linear_1_2)"
      />
      <path
        d="M179.17 100.4C180.09 97.84 180.86 95.2 180.97 92.5C180.97 92.41 181.01 92.3 180.94 92.22C180.87 92.15 180.72 92.18 180.7 92.28C180.2 94.91 179.14 97.24 178.16 99.47C178.5 99.78 178.83 100.1 179.17 100.41V100.4Z"
        fill="url(#paint72_linear_1_2)"
      />
      <path
        d="M177.02 98.37C177.67 96.43 178.12 94.58 178.35 92.58C178.35 92.14 177.58 92.13 177.59 92.58C177.34 94.13 176.71 95.78 176.02 97.35C176.36 97.69 176.69 98.03 177.03 98.37H177.02Z"
        fill="url(#paint73_linear_1_2)"
      />
      <path
        d="M204.95 97.83C204.51 98.25 204.04 98.65 203.61 99.07C203.58 99.13 203.61 99.2 203.67 99.23C203.7 99.27 203.79 99.23 203.82 99.23C204.33 98.85 204.93 98.53 205.39 98.1C205.52 97.87 205.15 97.64 204.95 97.83Z"
        fill="url(#paint74_linear_1_2)"
      />
      <path
        d="M189.87 113.94C190.08 113.91 189.98 113.93 189.87 113.94Z"
        fill="url(#paint75_linear_1_2)"
      />
      <path
        d="M208.99 115.63C203.07 113.67 195.49 113.25 189.87 113.94C189.76 113.95 189.65 113.97 189.87 113.94C189.78 113.94 189.69 113.96 189.6 113.98C189.52 114 189.45 114.03 189.41 114.04C189.42 114.04 189.43 114.04 189.46 114.02C189.36 114.06 189.25 114.09 189.16 114.15C189.09 114.19 189.02 114.23 188.96 114.28C188.95 114.28 188.94 114.3 188.93 114.3C188.93 114.3 188.94 114.3 188.95 114.3C188.66 114.52 188.8 114.92 189.11 115.03H189.12C189.15 115.04 189.18 115.05 189.22 115.05C189.03 115.35 189.11 115.79 189.48 115.96C189.52 115.98 189.56 115.99 189.6 116.01C189.61 116.01 189.62 116.02 189.64 116.03C189.65 116.03 189.67 116.04 189.68 116.05C192.11 116.55 193.9 117.18 196.47 118.54C197.71 119.21 200.13 120.33 201.39 121.54C201.35 121.49 201.48 121.68 201.52 121.71C201.62 121.79 201.79 121.66 201.71 121.56C201.16 120.81 200.3 120.26 199.59 119.64C197.86 118.16 195.9 116.94 193.78 115.97C192.85 115.5 191.64 115.07 190.77 114.87C191.96 114.62 193.08 114.45 194.78 114.43C198.22 114.2 201.82 114.51 205.04 114.89C206.38 115.08 207.71 115.34 208.96 115.83C209.08 115.86 209.15 115.68 209.02 115.65L208.99 115.63Z"
        fill="url(#paint76_linear_1_2)"
      />
      <path
        d="M208.36 114.45C207.36 113.99 206.22 113.89 205.14 113.69C202.97 113.36 200.8 112.96 198.6 112.81C196.28 112.64 193.94 112.63 191.61 112.73C190.58 112.77 189.77 112.72 189.25 113C188.87 113.24 189.12 113.78 189.54 113.77C189.55 113.77 189.56 113.77 189.57 113.77C189.63 113.77 189.71 113.77 189.77 113.77C194.04 113.05 201.92 112.9 207.66 114.41C207.85 114.47 208.05 114.58 208.28 114.67C208.41 114.69 208.49 114.51 208.36 114.45Z"
        fill="url(#paint77_linear_1_2)"
      />
      <path
        d="M198.75 121.49C195.82 119.12 194.28 117.57 190.55 116.25C190.03 116.1 189.62 116.73 190.01 117.07C190.07 117.12 190.12 117.15 190.17 117.17C190.17 117.17 190.17 117.17 190.16 117.17C190.17 117.17 190.19 117.18 190.2 117.19C192.34 118.08 194.89 119.02 197.24 120.59C197.7 120.93 198.14 121.3 198.5 121.73C198.65 121.87 198.91 121.65 198.75 121.51V121.49Z"
        fill="url(#paint78_linear_1_2)"
      />
      <path
        d="M198.82 123.78C196.94 121.63 195.1 120.16 192.65 118.9C192.3 118.72 192.09 118.65 191.97 118.61C191.87 118.57 191.74 118.54 191.63 118.55C191.52 118.53 191.37 118.51 191.26 118.5C191.22 118.5 191.17 118.49 191.13 118.5C191.1 118.5 191.07 118.5 191.04 118.52C190.99 118.5 190.81 118.46 190.77 118.44C190.64 118.41 190.52 118.3 190.38 118.29C190.15 118.43 190.64 118.52 190.71 118.6C190.77 118.63 190.87 118.71 190.92 118.74C190.92 118.77 190.94 118.79 190.96 118.82C190.96 118.82 190.96 118.84 190.98 118.85C191.07 118.94 191.16 119.03 191.25 119.12C191.28 119.15 191.3 119.17 191.32 119.18C191.4 119.28 191.52 119.35 191.62 119.42C191.63 119.42 191.64 119.42 191.64 119.42C191.64 119.42 191.65 119.42 191.66 119.43C191.88 119.58 192.14 119.68 192.37 119.81C194.1 120.72 196.02 121.7 197.42 122.73C197.76 122.97 198.17 123.36 198.37 123.6C198.49 123.71 198.54 123.88 198.68 123.96C198.78 123.99 198.88 123.88 198.82 123.8V123.78Z"
        fill="url(#paint79_linear_1_2)"
      />
      <path
        d="M85.22 31.83C84.82 29.4 83.92 26.59 82.74 24.27C81.85 22.42 81.1 20.36 80.35 18.33C80.32 18.22 80.12 18.26 80.16 18.38C81.74 22.5 82.75 26.46 84.23 30.59C84.4 31.33 84.55 32.75 84.56 33.93C84.64 34.35 84.5 34.33 84.7 34.64C85.75 35.29 85.28 32.33 85.21 31.82L85.22 31.83Z"
        fill="url(#paint80_linear_1_2)"
      />
      <path
        d="M86.23 30.2C84.93 27.03 83.78 24.24 82.3 21.03C82.22 20.9 82.19 20.71 82.04 20.63C81.94 20.6 81.85 20.71 81.9 20.79C82.97 22.81 83.6 25.14 84.27 27.36C85.08 29.63 85.32 31.54 85.68 33.14C85.65 33.35 86.05 33.92 86.52 33.41C86.79 32.73 86.57 31.2 86.22 30.19L86.23 30.2Z"
        fill="url(#paint81_linear_1_2)"
      />
      <path
        d="M85.9 25.61C85.34 24.39 84.75 23.17 84.23 21.77C84.18 21.61 83.9 21.67 83.95 21.84C84.42 23.22 85.04 24.56 85.41 25.97C85.79 27.63 86.22 29.27 86.68 30.91C86.81 31.26 86.9 31.66 87.13 31.98C87.13 32 87.15 32.02 87.16 32.05C87.19 32.09 87.22 32.13 87.25 32.16C87.25 32.16 87.27 32.18 87.26 32.17C87.52 32.47 88.02 32.33 88.16 32.03C88.16 32.01 88.18 31.97 88.2 31.92C88.72 31.11 86.8 27.13 85.88 25.59L85.9 25.61Z"
        fill="url(#paint82_linear_1_2)"
      />
      <path
        d="M89.43 28.95C89.06 27.61 88.43 26.66 87.89 25.41C87.52 24.75 87.34 23.95 86.9 23.35C86.65 23.21 86.31 23.44 86.4 23.7C87.28 25.51 88.01 27.93 88.85 29.43C89.3 29.8 89.62 29.3 89.43 28.96V28.95Z"
        fill="url(#paint83_linear_1_2)"
      />
      <path
        d="M91.81 28.01C91.18 26.35 90.68 24.64 89.96 23.02C89.63 22.58 88.81 22.95 88.99 23.46C89.61 25.37 90.37 27.25 90.94 29.17C91.03 29.4 91.07 29.67 91.33 29.8C91.65 29.98 92.1 29.8 92.2 29.48C92.26 28.98 91.94 28.49 91.81 28.01Z"
        fill="url(#paint84_linear_1_2)"
      />
      <path
        d="M93.43 25.04C93.09 24.21 93.08 24.13 92.67 23.43C92.44 23.05 91.76 23.31 91.9 23.72C92.08 24.27 92.6 25.52 92.74 25.68C92.83 26 93.35 26.06 93.52 25.77C93.66 25.53 93.48 25.28 93.43 25.03V25.04Z"
        fill="url(#paint85_linear_1_2)"
      />
      <path
        d="M95.57 22.99C95.57 22.99 95.57 22.99 95.57 22.97C95.57 22.98 95.57 23 95.57 23.01C95.51 22.76 95.49 22.47 95.34 22.26C95.04 21.86 94.3 22.2 94.46 22.66C94.52 22.89 94.58 23.12 94.7 23.33C94.76 23.45 94.72 23.36 94.7 23.31C94.76 23.53 95.03 23.66 95.27 23.6C95.71 23.44 95.6 23.15 95.58 23L95.57 22.99Z"
        fill="url(#paint86_linear_1_2)"
      />
      <path
        d="M102.53 24.57C102.53 24.57 102.53 24.49 102.5 24.43C102.5 24.41 102.5 24.4 102.49 24.4C102.44 24.28 102.38 24.17 102.46 24.33C100.86 21.49 98.76 17.63 97.36 14.34C96.84 13.24 96.49 12.06 95.87 11.01C95.7 10.88 95.45 11.08 95.56 11.25C97.54 15.33 99.1 20.14 101.02 24.07C101.18 24.33 101.38 24.55 101.6 24.76C101.62 24.77 101.61 24.77 101.63 24.78C101.63 24.78 101.64 24.8 101.65 24.81C101.68 24.84 101.72 24.87 101.76 24.89C101.81 24.93 101.87 24.97 101.94 24.99C102.1 25.03 102.27 24.99 102.39 24.88C102.51 24.81 102.52 24.66 102.51 24.54C102.51 24.55 102.51 24.56 102.51 24.57H102.53Z"
        fill="url(#paint87_linear_1_2)"
      />
      <path
        d="M100.59 24.22C100.59 24.22 100.6 24.25 100.61 24.27L100.58 24.19C100.2 23.24 98.88 21.07 98.49 20.11C98.28 19.63 97.76 18.39 97.59 17.59C97.53 17.43 97.57 17.22 97.39 17.12C97.19 17.01 96.91 17.19 96.98 17.4C97.55 19.6 98.27 22.23 99.28 24.28C99.53 24.65 99.55 24.7 99.72 24.83C100.02 25.07 100.53 24.9 100.62 24.56C100.67 24.45 100.62 24.28 100.59 24.21V24.22Z"
        fill="url(#paint88_linear_1_2)"
      />
      <path
        d="M98.63 23.68C98.12 22.75 97.52 21.6 97.19 20.86C97.11 20.73 96.94 20.26 96.84 19.98C96.75 19.86 96.51 19.93 96.52 20.08C96.7 21.44 97.2 22.76 97.7 24.04C97.89 24.51 98.05 25 98.37 25.41C98.64 25.85 99.42 25.65 99.41 25.16C99.28 24.63 98.88 24.18 98.63 23.69V23.68Z"
        fill="url(#paint89_linear_1_2)"
      />
      <path
        d="M139.93 108.83C144.16 103.77 148.81 100.05 155.08 96.74C159.33 94.33 163.96 92.52 168.49 90.6C173.27 88.65 177.83 86.7 182.19 85.05C185.27 83.84 188.52 82.75 191.74 81.57C192.6 81.21 193.56 80.98 194.36 80.53C194.38 80.47 194.29 80.4 194.23 80.44C186.29 83.17 176.99 85.91 170.51 88.52C165.11 90.64 159.23 92.72 153.84 95.77C149.01 98.65 143.41 102.79 139.24 107.68"
        fill="url(#paint90_linear_1_2)"
      />
      <path
        d="M141.13 104.91C148 97.61 156.95 92.83 166.7 88.97C173.36 86.28 180.92 83.95 188.02 81.52C188.12 81.38 187.96 81.18 187.78 81.24C186.13 81.73 184.48 82.23 182.84 82.74C177.61 84.35 172.43 86.09 167.29 87.93C158.65 90.77 150.59 95.25 143.92 101.14C146.18 99.01 148.56 96.97 150.79 95.47C156.01 91.83 163.04 88.7 169.48 86.21C172.07 85.24 174.71 84.36 177.36 83.54C177.55 83.45 177.8 83.44 177.95 83.31C177.95 83.28 177.92 83.24 177.88 83.25C168.87 86.26 159.55 88.95 151.57 93.91"
        fill="url(#paint91_linear_1_2)"
      />
      <path
        d="M138.79 106.29C137.34 107.95 135.97 109.7 134.74 111.53Z"
        fill="url(#paint92_linear_1_2)"
      />
      <path
        d="M132.91 110.32C137.18 104.93 142.37 99.55 148.39 95.22C151.82 92.72 156.34 90.42 160.46 88.42C165.14 86.19 169.94 84.48 174.85 82.77C175.26 82.16 172.67 83.31 172.5 83.28C168.69 84.52 164.96 85.95 161.3 87.51"
        fill="url(#paint93_linear_1_2)"
      />
      <path
        d="M143.09 97.05C146.78 94.13 150.08 91.68 154.2 89.3C157.9 87.14 162.27 85.22 166.01 83.56C156.49 86.68 147.5 91.78 140.75 97.49"
        fill="url(#paint94_linear_1_2)"
      />
      <path
        d="M127.34 109.53C131 104.38 134.92 100.02 140.26 95.79C144.58 92.37 149.52 89.57 154.64 86.9C157.57 85.31 160.82 84.03 163.75 82.58C163.75 82.5 163.63 82.46 163.56 82.51C163.34 82.59 163.11 82.67 162.89 82.75C160.14 83.75 157.44 84.87 154.84 86.16C142.02 92.31 130.79 101.16 124.29 112.79"
        fill="url(#paint95_linear_1_2)"
      />
      <path
        d="M127.32 105.64C131.43 100.7 137.07 94.87 142.99 90.65C145.67 88.67 148.99 86.9 152.16 85.3C153.16 84.78 154.2 84.33 155.2 83.82C155.31 83.7 155.14 83.5 154.98 83.59C144.77 87.98 135.79 94.44 128.49 102.22"
        fill="url(#paint96_linear_1_2)"
      />
      <path
        d="M130.25 98.04C134.28 94.22 138.42 90.68 143.31 87.87C144.16 87.3 145.12 86.83 145.93 86.24C145.96 86.15 145.88 86.06 145.78 86.06C145.71 86.06 145.65 86.11 145.59 86.14C144.76 86.61 143.93 87.08 143.11 87.56C139.23 89.79 135.74 92.49 132.43 95.37C129.33 98.04 126.26 100.76 123.54 103.75"
        fill="url(#paint97_linear_1_2)"
      />
      <path
        d="M123.98 75.68C123.8 75.46 123.39 75.64 123.48 75.91C123.54 76.09 123.55 76.49 123.55 76.83C123.17 80.54 120.22 83.6 116.7 86.26C112.3 89.59 109.23 91.64 104.61 94.74C99.04 98.35 93.69 102.28 89.25 107.02C88.08 108.24 86.9 109.46 85.8 110.73C85.75 110.83 85.91 110.94 86 110.85C92.29 103.87 99.42 99.13 107.28 94.05C111.45 91.33 115.68 88.65 119.45 85.48C121.63 83.29 123.91 80.29 124.19 76.93C124.2 76.51 124.19 76.06 123.99 75.68H123.98Z"
        fill="url(#paint98_linear_1_2)"
      />
      <path
        d="M95.06 105.04C99.58 101.32 103.51 98.42 108.23 95.43C114.71 91.24 122.26 87.27 124.89 80.39C125.38 79.26 125.55 77.99 125.38 76.85C125.38 76.74 125.36 76.61 125.22 76.57C124.71 76.45 124.95 77.18 124.9 77.34C124.84 78.31 124.76 79.1 124.36 80.04C123.52 82.1 122.17 83.76 120.45 85.36C115.92 89.74 111.15 92.25 105.69 95.93C99.68 100.06 93.88 104.57 89.15 109.91"
        fill="url(#paint99_linear_1_2)"
      />
      <path
        d="M90.87 110.6C96.56 104.48 103.3 99.91 110.75 95.73C116.69 92.56 122.51 88.25 125.54 82.86C126.04 81.93 126.51 80.97 126.7 79.92C126.7 79.81 126.77 79.7 126.72 79.59C126.66 79.49 126.48 79.51 126.45 79.62C125.73 82.25 123.69 84.41 122.08 86.3C118.08 90.88 112.85 93.48 107.47 96.65C101.08 100.44 95.36 105.13 90.46 110.43"
        fill="url(#paint100_linear_1_2)"
      />
      <path
        d="M120.58 90.23C116.78 93.33 112.61 95.72 108.22 98.28C105.08 100.13 102.13 102.24 99.31 104.47C97.66 105.79 96.05 107.18 94.67 108.73C94.6 108.85 94.44 108.94 94.44 109.08C94.47 109.17 94.61 109.19 94.66 109.11C96.2 107.22 98.73 105.55 100.55 104.25C107.05 99.68 114.83 96.14 120.62 90.68C120.8 90.47 121.09 90.3 121.19 90.07C121.08 89.73 120.76 90.13 120.59 90.23H120.58Z"
        fill="url(#paint101_linear_1_2)"
      />
      <path
        d="M112.31 98.22C109.26 99.87 105.62 101.8 102.58 103.83C100.56 105.14 98.79 106.71 96.9 108.16C96.66 108.38 96.31 108.56 96.17 108.83C96.17 108.94 96.33 109.01 96.42 108.92C101.18 104.88 106.98 102.05 112.58 98.68C112.74 98.54 112.71 98.64 112.74 98.41C112.73 98.24 112.48 98.13 112.32 98.22H112.31Z"
        fill="url(#paint102_linear_1_2)"
      />
      <path
        d="M106.47 103.11C104.6 104.13 102.39 105.94 100.49 107.32C99.59 108.01 98.6 108.63 97.78 109.39C97.67 109.6 98 109.81 98.18 109.63C101 107.33 104.5 105.37 106.86 103.5C107.07 103.28 106.74 102.95 106.48 103.11H106.47Z"
        fill="url(#paint103_linear_1_2)"
      />
      <path
        d="M175.41 62C161.94 64.82 147.98 64.97 134.7 62.09C132.08 61.65 129.51 61.01 126.92 60.44C126.58 60.34 126.17 60.4 125.96 60.68C125.7 60.95 125.75 61.39 126.02 61.64C126.35 61.91 126.86 61.91 127.27 62.03C129.03 62.41 130.82 62.69 132.59 63.03C140.7 64.44 148.91 65.2 157.79 64.76C170.42 64.1 183.64 61.17 194.63 56.09C188.35 58.38 182.08 60.81 175.4 62.01L175.41 62Z"
        fill="url(#paint104_linear_1_2)"
      />
      <path
        d="M192.81 57.99C189.95 59.14 186.92 60.08 184.07 61.16C184.07 61.34 184.29 61.23 184.4 61.2C186.08 60.7 187.73 60.11 189.35 59.48C190.54 59.02 191.7 58.53 192.84 58.12C192.93 58.1 192.89 57.97 192.8 58L192.81 57.99Z"
        fill="url(#paint105_linear_1_2)"
      />
      <path
        d="M182.02 61.94C164.13 66.5 143.75 66.4 126.84 61.99C126.35 61.87 125.85 61.72 125.34 61.74C125.28 61.74 125.25 61.74 125.2 61.75C125.15 61.75 125.1 61.73 125.05 61.75C124.75 61.77 124.53 62.02 124.52 62.29C124.45 62.63 125.13 62.92 124.91 62.78C125.1 62.89 125.31 62.96 125.51 63.05C138.34 66.33 152 66.7 165.19 65.27C169.92 64.78 174.82 63.86 179.51 62.75C180.38 62.52 181.3 62.38 182.13 62.1C182.18 62.03 182.1 61.94 182.01 61.96L182.02 61.94Z"
        fill="url(#paint106_linear_1_2)"
      />
      <path
        d="M150.75 67.11C141.4 66.92 132.9 65.72 123.6 63.59C123.31 63.55 123 63.42 122.73 63.57C122.27 63.8 122.36 64.47 122.88 64.59C137.03 68.16 151.93 68.18 166.55 66.26C161.29 66.62 156.03 67.21 150.75 67.11Z"
        fill="url(#paint107_linear_1_2)"
      />
      <path
        d="M155.62 68.53C149.26 68.79 143.04 68.61 136.9 67.93C133.22 67.37 129.59 66.46 125.91 65.88C125.87 65.86 125.82 65.85 125.76 65.85C124.61 65.49 123.45 65.16 122.25 64.99C121.9 64.94 121.54 64.87 121.19 64.93C121.08 64.93 121.03 64.98 120.99 65.05C120.9 65.05 120.85 65.05 120.7 65.05C120.12 65.09 120.02 65.84 120.5 66.06C127.06 68.14 134.11 68.58 141.02 68.85C145.4 68.99 149.79 69.08 154.16 68.83C154.66 68.76 155.26 68.83 155.71 68.66C155.74 68.61 155.69 68.54 155.62 68.54V68.53Z"
        fill="url(#paint108_linear_1_2)"
      />
      <path
        d="M120.54 66.07C120.54 66.07 120.59 66.1 120.62 66.1C120.62 66.1 120.58 66.08 120.54 66.07Z"
        fill="url(#paint109_linear_1_2)"
      />
      <path
        d="M120.54 66.07C120.54 66.07 120.51 66.06 120.5 66.05C120.5 66.05 120.5 66.05 120.49 66.05C120.5 66.05 120.52 66.06 120.54 66.07Z"
        fill="url(#paint110_linear_1_2)"
      />
      <path
        d="M142.71 70.31C135.03 69.98 127.74 68.64 120.14 67.3C119.65 67.23 119.77 67.24 119.07 67.21C118.89 67.19 118.69 67.24 118.56 67.36C117.91 68.26 119.19 68.32 119.88 68.45C124.15 69.17 130.18 69.64 135.81 70.1C138.11 70.25 140.41 70.43 142.72 70.49C142.84 70.49 142.85 70.31 142.72 70.31H142.71Z"
        fill="url(#paint111_linear_1_2)"
      />
      <path
        d="M114.97 78.99C114.97 78.99 114.97 78.96 114.97 78.94C114.97 78.92 114.97 78.91 114.97 78.89C114.97 78.89 114.97 78.94 114.96 78.98L114.97 78.99Z"
        fill="url(#paint112_linear_1_2)"
      />
      <path
        d="M120.81 74.83C118.69 75.02 116.62 76.12 115.88 77.12C115.39 77.64 115.05 78.27 114.98 78.95C114.97 79.04 114.96 79.13 114.96 79.22C114.96 79.25 114.96 79.29 114.97 79.34C114.97 79.37 114.97 79.4 114.97 79.43C114.97 79.41 114.97 79.41 114.97 79.39C115 79.53 115.07 79.69 115.21 79.75C115.55 80.02 116.14 79.84 116.26 79.45C116.26 79.44 116.26 79.43 116.28 79.41C116.31 79.27 116.46 78.85 116.48 78.8C116.68 78.35 116.85 78.01 117.35 77.34C117.78 76.83 118.49 76.1 119.63 75.55C120.06 75.37 120.35 75.25 120.91 75.14C121.14 75.09 121.04 74.76 120.81 74.82V74.83Z"
        fill="url(#paint113_linear_1_2)"
      />
      <path
        d="M116.28 79.43C116.28 79.43 116.28 79.43 116.28 79.44C116.28 79.44 116.28 79.46 116.27 79.47C116.27 79.46 116.28 79.45 116.29 79.43H116.28Z"
        fill="url(#paint114_linear_1_2)"
      />
      <path
        d="M116.26 79.47C116.22 79.56 116.22 79.54 116.26 79.47Z"
        fill="url(#paint115_linear_1_2)"
      />
      <path
        d="M76.13 106.45C75.32 105.5 73.74 103.86 72.55 102.01C71.47 100.39 70.69 98.53 69.95 96.99C69.3 95.66 68.78 94.28 68.39 92.87C68.17 92.26 68.1 91.54 67.71 91.01C67.52 90.9 67.26 91.08 67.33 91.28C68.62 94.7 70.11 98.4 71.59 101.54C72.49 103.49 73.74 105.33 75.32 106.9C75.67 107.19 75.71 107.36 76.06 107.4C76.81 107.25 76.39 106.72 76.12 106.45H76.13Z"
        fill="url(#paint116_linear_1_2)"
      />
      <path
        d="M71.44 103.22C69.97 100.28 68.24 97.3 67.02 94.53C66.55 93.29 66.2 92.01 65.82 90.75C65.77 90.58 65.47 90.65 65.52 90.82C66.59 94.32 67.77 97.81 69.4 101.14C69.89 102.13 70.65 103.51 71.07 103.96C71.29 104.13 71.65 103.96 71.65 103.71C71.6 103.47 71.53 103.4 71.45 103.22H71.44Z"
        fill="url(#paint117_linear_1_2)"
      />
      <path
        d="M64.06 90.23C63.93 90.07 63.62 90.2 63.69 90.4C64.71 94.25 66.01 98.59 68.1 101.87C68.18 102.02 68.46 102 68.51 101.83C68.51 101.81 68.51 101.79 68.51 101.77C67.51 98.55 65.93 95.01 64.71 92.43C64.46 91.71 64.31 90.96 64.06 90.24V90.23Z"
        fill="url(#paint118_linear_1_2)"
      />
      <path
        d="M68.51 101.76C68.51 101.68 68.47 101.65 68.51 101.76Z"
        fill="url(#paint119_linear_1_2)"
      />
      <path
        d="M66.12 100.22C65.62 99.07 64.61 96.98 63.96 95.05C63.52 93.83 63.28 92.55 62.86 91.34C62.67 91.1 62.22 91.3 62.32 91.59C62.91 93.88 63.6 96.15 64.47 98.37C64.77 99.15 65.2 100.34 65.61 100.76C66.15 101.03 66.32 100.48 66.14 100.23L66.12 100.22Z"
        fill="url(#paint120_linear_1_2)"
      />
      <path
        d="M61.03 92.16C60.95 91.98 60.99 91.73 60.8 91.6C60.62 91.5 60.37 91.67 60.44 91.85C61.14 94.48 61.96 97.45 63.14 99.78C63.2 100 63.58 99.91 63.51 99.69C62.66 97.19 61.86 94.67 61.03 92.16Z"
        fill="url(#paint121_linear_1_2)"
      />
      <path
        d="M58.98 92.49C58.95 92.32 58.98 92.13 58.84 92C58.63 91.8 58.23 91.95 58.24 92.22C58.31 92.6 58.37 93.92 59.06 93.32C59.17 93.05 58.99 92.76 58.98 92.48V92.49Z"
        fill="url(#paint122_linear_1_2)"
      />
      <path
        d="M30.12 145.65C29.15 141.64 28.26 137.68 27.74 133.76C27.5 131.68 28.33 129.73 28.77 127.63C28.8 127.16 29.29 126.39 29.16 126.06C29.01 125.85 28.55 125.89 28.47 126.13C27.23 129.53 27 133.08 27.46 136.57C27.78 140.24 29.54 150.25 30.54 153.84"
        fill="url(#paint123_linear_1_2)"
      />
      <path
        d="M31.36 142.26C31.02 140.27 30.74 138.22 30.29 136.17C30.16 135.81 29.39 135.96 29.54 136.33C30.15 138.95 32.26 148.24 32.84 150.76"
        fill="url(#paint124_linear_1_2)"
      />
      <path
        d="M79.36 110.58C79.04 110.29 78.71 110.01 78.38 109.73C78.05 109.47 77.98 109.34 77.66 109.11C77.39 108.99 77.13 109.34 77.35 109.53C77.65 109.89 78.17 110.65 78.91 111.15C79.12 111.28 79.24 111.48 79.58 111.26C79.84 111.02 79.57 110.76 79.36 110.58Z"
        fill="url(#paint125_linear_1_2)"
      />
      <path
        d="M77.51 110.98C76.39 109.76 75.03 108.74 73.98 107.47C73.59 107.01 73.22 106.53 72.82 106.07C72.51 105.78 72.01 106.23 72.33 106.51C73.61 108.03 74.99 109.73 76.65 111.32C77 111.57 76.99 111.78 77.45 111.67C77.91 111.47 77.65 111.05 77.52 110.97L77.51 110.98Z"
        fill="url(#paint126_linear_1_2)"
      />
      <path
        d="M72.92 109.97C73.47 110.67 73.73 111.01 74.36 111.68C74.47 111.78 74.66 111.82 74.8 111.75C75.5 111.34 74.5 110.81 74.16 110.31C72.94 109.01 71.91 108.02 71.14 106.44C70.6 105.48 69.99 104.4 69.65 103.6C69.55 103.25 68.94 103.4 69.05 103.75"
        fill="url(#paint127_linear_1_2)"
      />
      <path
        d="M190.17 130.71C190.09 128.91 189.77 127.13 189.57 125.35C189.08 122.02 189.12 118.59 188.1 115.33C187.39 113.2 186.3 111.2 185.1 109.17C184.3 107.81 183.52 106.43 182.41 105.25C179.56 102.29 176.23 99.74 172.88 97.25C172.49 96.99 172.16 96.62 171.75 96.42C171.6 96.42 171.51 96.6 171.62 96.69C175.73 99.71 180.21 102.85 183.02 106.87C184.58 109.45 186.22 112.08 187.27 114.8C188.21 117.67 188.3 120.38 188.7 123.39C189.12 126.03 189.1 128.92 189.71 131.39C189.81 131.49 190 131.49 190.1 131.39C190.26 131.2 190.14 130.92 190.17 130.7V130.71Z"
        fill="url(#paint128_linear_1_2)"
      />
      <path
        d="M182.64 107.25C179.52 103.67 175.63 100.7 171.86 97.69C171.42 97.41 170.96 96.75 170.4 96.8C170.17 96.85 170.02 97.09 170.09 97.29C170.29 97.67 171.63 98.34 171.82 98.53C174.67 100.53 178.01 103.08 180.01 105.42C183.03 109.12 185.46 112.94 186.46 117.37C187.11 120.41 187.5 123.28 187.57 126.4C187.58 126.51 187.55 126.63 187.64 126.71C187.77 126.84 188.04 126.75 188.03 126.56C187.76 119.85 186.54 112.99 182.62 107.25H182.64Z"
        fill="url(#paint129_linear_1_2)"
      />
      <path
        d="M180.95 108.29C177.73 104.21 172 99.69 168.22 97.13C167.83 96.8 167.16 96.93 167.27 97.49C167.43 97.82 167.58 97.79 167.97 98.13C171.17 100.64 174.59 102.93 177.58 105.66C179.74 107.84 181.62 109.68 183.2 112.18C184.19 113.86 184.86 115.52 185.61 117.31C185.7 117.42 185.92 117.33 185.87 117.19C184.59 114.08 183.19 110.95 180.96 108.29H180.95Z"
        fill="url(#paint130_linear_1_2)"
      />
      <path
        d="M182.95 114C179.99 109.12 175.67 105.03 170.8 101.67C168.47 100.02 165.93 98.16 163.63 97.17C163.21 96.92 162.67 97.38 162.94 97.77C163.14 98.01 163.5 98.09 163.75 98.29C167.85 101.02 172.14 103.1 175.58 106.06C177.8 108 179.53 110 181.23 112.14C181.77 112.8 182.21 113.53 182.7 114.21C182.85 114.32 183.09 114.15 182.98 113.99L182.95 114Z"
        fill="url(#paint131_linear_1_2)"
      />
      <path
        d="M178.31 110.53C174.84 107.58 171.15 104.56 167.63 102.21C166.17 101.21 164.58 100.28 162.86 99.43C162.21 99.16 161.58 98.69 160.86 98.64C160.49 98.66 160.28 99.08 160.47 99.36C160.48 99.5 161.02 99.67 161.03 99.66H161.04C163.83 100.66 168.11 102.64 170.85 104.94C173.26 106.84 175.61 108.8 178.01 110.71C178.14 110.9 178.49 110.7 178.3 110.52L178.31 110.53Z"
        fill="url(#paint132_linear_1_2)"
      />
      <path
        d="M171.92 107.8C168.21 104.88 164.07 102.34 159.54 100.57C158.74 100.28 157.95 99.95 157.1 99.79C156.78 99.75 156.39 99.66 156.14 99.89C155.92 100.08 155.92 100.42 156.14 100.62C156.37 100.82 156.74 100.77 157.02 100.87C161.1 102.21 164.4 103.19 168.12 105.62C169.14 106.27 169.91 106.8 170.77 107.42C171.12 107.63 171.39 107.98 171.76 108.13C171.94 108.13 172.05 107.91 171.91 107.8H171.92Z"
        fill="url(#paint133_linear_1_2)"
      />
      <path
        d="M167.38 107.32C167.52 107.29 167.58 107.11 167.47 107.02Z"
        fill="url(#paint134_linear_1_2)"
      />
      <path
        d="M158.02 102.35C157.79 102.32 157.53 102.21 157.3 102.3C157.05 102.38 156.94 102.69 157.08 102.89C157.61 103.29 158.65 103.48 159.52 103.85"
        fill="url(#paint135_linear_1_2)"
      />
      <path
        d="M190.22 132.49C190.21 132.41 190.07 132.35 189.95 132.38C189.82 132.41 189.75 132.51 189.8 132.59C190.4 133.96 190.09 135.26 190.08 136.68C189.86 139.93 189.54 143.19 189.22 146.43C189.3 146.7 189.96 146.64 190 146.35C190.3 142.1 191.01 137.78 190.45 133.58C190.38 133.21 190.33 132.85 190.23 132.49H190.22Z"
        fill="url(#paint136_linear_1_2)"
      />
      <path
        d="M187.05 145.4C187.23 145.55 187.61 145.52 187.79 145.35C188.07 144.77 188 144.13 188.13 143.53C188.35 141.33 188.44 139.18 188.43 136.74C188.39 136.13 188.43 135.49 188.31 134.89C188.24 134.8 188 134.87 188.02 134.98C188.08 136.31 188.1 137.45 187.95 138.78"
        fill="url(#paint137_linear_1_2)"
      />
      <path
        d="M94.58 8.75999C94.43 8.52999 94.11 8.40999 93.82 8.47999C94.62 8.47999 93.55 8.46999 93.26 8.54999C90.29 9.42999 84.14 12.32 81.1 14.17C80.83 14.33 80.49 14.46 80.4 14.77C80.21 15.33 80.95 15.84 81.5 15.53C81.96 15.3 82.41 15.07 82.87 14.84C82.98 15.19 83.46 15.43 83.85 15.21C84.14 15.02 84.63 14.86 84.64 14.81C85.15 14.69 85.67 14.31 86.14 14.15C88.42 12.95 91.88 11.57 92.27 10.74C92.28 10.72 92.29 10.71 92.29 10.7C92.29 10.7 92.29 10.7 92.29 10.69C92.31 10.66 92.31 10.64 92.31 10.64C92.33 10.59 92.34 10.53 92.34 10.48C92.65 10.36 92.99 10.23 93.45 10.08C93.81 9.97999 94.1 9.75999 94.39 9.56999C94.41 9.55999 94.42 9.54999 94.43 9.54999C94.67 9.36999 94.76 9.02999 94.59 8.77999L94.58 8.75999Z"
        fill="url(#paint138_linear_1_2)"
      />
      <path
        d="M132.01 0.42C132.01 0.42 132.01 0.42 132 0.42C131.85 0.35 131.67 0.31 131.52 0.28C129.99 0.1 128.45 0.04 126.91 0C124.84 0.04 122.74 -0.02 120.69 0.15C120.21 0.3 120.37 1 120.88 0.98C122.2 0.91 123.53 0.89 124.85 0.91C124.83 0.91 124.8 0.92 124.76 0.94C124.76 0.94 124.75 0.95 124.74 0.96C124.45 1.07 124.43 1.47 124.71 1.61C124.73 1.61 124.74 1.61 124.76 1.62C124.76 1.62 124.78 1.63 124.83 1.65C124.86 1.65 124.9 1.65 124.93 1.65C125.27 1.69 125.62 1.71 125.97 1.69C127.86 1.56 130.21 1.34 131.21 1.23C131.45 1.25 131.68 1.26 131.89 1.2C131.97 1.2 132.05 1.2 132.22 1.17C132.68 1 132.47 0.4 132 0.41L132.01 0.42Z"
        fill="url(#paint139_linear_1_2)"
      />
      <path
        d="M131.6 0.290009C131.6 0.290009 131.58 0.290009 131.56 0.290009C131.61 0.290009 131.66 0.300009 131.6 0.290009Z"
        fill="url(#paint140_linear_1_2)"
      />
      <path
        d="M155.36 6.60999C154.65 5.93999 154.1 5.00999 153.06 4.70999C152.95 4.70999 152.84 4.74999 152.77 4.79999C152.75 4.80999 152.74 4.81999 152.72 4.83999C152.72 4.83999 152.72 4.83999 152.72 4.84999C152.68 4.84999 152.64 4.86999 152.6 4.87999C152.6 4.87999 152.6 4.87999 152.6 4.86999C152.55 4.72999 152.29 4.76999 152.3 4.91999C152.3 4.95999 152.32 4.99999 152.32 5.03999C152.16 5.19999 152.09 5.43999 152.24 5.64999C152.37 5.80999 152.49 5.97999 152.61 6.14999C153.25 7.82999 154.74 9.25999 156.27 10.31C156.73 10.56 157.24 10.97 157.82 10.88C159.34 10.12 156.08 7.41999 155.37 6.60999H155.36Z"
        fill="url(#paint141_linear_1_2)"
      />
      <path
        d="M202.47 73.44C202.18 70.73 200.97 66.64 200.48 63.79C200.16 62.46 199.88 61.01 199.25 59.32C199.09 58.99 198.98 58.52 198.74 58.19C198.69 58.04 198.64 57.89 198.56 57.75C198.35 57.47 197.91 57.6 197.79 57.86C197.47 57.96 197.27 58.26 197.21 58.56C197.18 58.64 197.2 58.63 197.23 58.59C197.03 59.16 197.05 59.78 197.02 60.37C197.06 61.01 197.13 61.64 197.2 62.27C196.83 65.28 197.86 69.9 199.19 72.38C199.2 72.4 199.21 72.41 199.22 72.42C199.23 72.44 199.24 72.46 199.25 72.48C199.42 73.14 199.61 73.79 199.8 74.44C199.88 74.64 199.97 74.86 200.15 75.01C200.33 75.18 200.55 75.24 200.77 75.24C200.8 75.34 200.82 75.44 200.86 75.54C200.97 75.69 201.13 75.75 201.3 75.77C201.27 75.89 201.23 76 201.17 76.17C201.04 76.76 202.01 77.06 202.33 76.53C202.77 75.57 202.54 74.47 202.46 73.46L202.47 73.44Z"
        fill="url(#paint142_linear_1_2)"
      />
      <path
        d="M39.6 186.59C37.13 180.44 34.69 174.65 34.7 168.4C34.63 168.09 34.77 167.99 34.49 167.57C33.77 167.19 33.66 167.82 33.58 168.16C33.06 170.63 33.69 174.37 34.69 177.2C36.33 182.31 38.49 186.47 41.08 191.41C43.2 195.56 45.4 199.69 47.6 203.81C48.93 206.24 50.26 209.17 51.92 211.21C47.12 203.26 43.18 194.98 39.6 186.59Z"
        fill="url(#paint143_linear_1_2)"
      />
      <path
        d="M37.26 175.59C39.01 180.55 41.05 185.42 43.18 190.25C43.71 191.31 44.01 192.56 44.64 193.53C44.72 193.53 44.77 193.45 44.73 193.39"
        fill="url(#paint144_linear_1_2)"
      />
      <path
        d="M39.38 174.94C40.1 177 40.88 179.05 41.66 181.09C41.69 181.19 41.88 181.16 41.85 181.04C40.23 176.51 39.16 171.82 38.32 167.13"
        fill="url(#paint145_linear_1_2)"
      />
      <path
        d="M40.03 167.08C40.46 168.84 40.95 170.6 41.62 172.3C41.66 172.44 41.93 172.39 41.88 172.24C40.91 169.43 40.81 167.15 40.4 164.48"
        fill="url(#paint146_linear_1_2)"
      />
      <path
        d="M96.33 246.34C94.37 244.83 92.46 243.39 90.45 241.97C79.79 234.07 65.27 221.91 56.59 212.17C53.32 208.45 50.46 204.6 47.8 200.51C47.01 199.22 46.46 197.88 45.84 196.52C45.77 196.4 45.76 196.24 45.65 196.15C45.55 196.09 45.4 196.19 45.44 196.3C46.61 199.02 48.14 202.04 49.67 204.38C52.99 209.21 57.12 213.56 61.39 217.73C69.43 225.45 81.95 236.54 91.11 243.01C92.84 244.32 94.56 245.68 96.31 246.95C96.42 247.06 96.65 247.06 96.73 246.92C96.87 246.66 96.5 246.52 96.34 246.36L96.33 246.34Z"
        fill="url(#paint147_linear_1_2)"
      />
      <path
        d="M90.13 239.84C77.05 230.06 60.99 215.52 52.68 202.55C49.86 198.35 47.41 193.96 45.13 189.5C44.36 187.99 43.72 186.41 42.89 184.93C42.8 184.86 42.65 184.97 42.72 185.07C45.71 190.98 47.59 196.78 50.82 201.91C53.58 206.47 56.64 209.59 60.27 213.7C67.74 221.83 80.67 232.68 89.55 239.5C91.29 240.77 93.01 242.13 94.77 243.34C93.3 242.15 91.65 241.02 90.13 239.84Z"
        fill="url(#paint148_linear_1_2)"
      />
      <path
        d="M74.01 224.07C66.49 217.2 60.33 209.63 55.01 201.19C50.09 193.49 45.99 185.55 43.24 177.03C43 176.33 42.76 175.62 42.54 174.91C42.52 174.85 42.47 174.81 42.4 174.8C42.28 174.78 42.18 174.9 42.22 174.99C42.43 175.75 42.65 176.51 42.88 177.26C45.79 185.79 50.01 194.46 54.65 202.01C58.55 208.64 63.44 214.78 69.26 220.14C70.77 221.52 72.32 222.87 73.87 224.21C73.97 224.25 74.07 224.12 73.99 224.05L74.01 224.07Z"
        fill="url(#paint149_linear_1_2)"
      />
      <path
        d="M43.3 167.12C46.04 181.04 52.92 194.05 60.89 206.12C63.58 210.04 66.59 213.79 69.99 217.24C71.08 218.3 72.19 219.37 73.45 220.27C73.53 220.31 73.62 220.21 73.55 220.15C60.47 209.32 48.1 183.65 43.91 168.07"
        fill="url(#paint150_linear_1_2)"
      />
      <path
        d="M56.73 192.7C60.5 199 64.26 206.01 69.21 211.34C65.31 206.6 62.23 201.37 59.21 196.15"
        fill="url(#paint151_linear_1_2)"
      />
      <path
        d="M120.72 251.71C114.67 252.82 107.41 253.12 102.33 252.14C102.27 252.13 102.22 252.11 102.16 252.1C102.19 252.1 102.2 252.11 102.22 252.12C102.16 252.1 102.06 252.08 102 252.07C102.2 252.14 102 252.07 101.86 252.04C101.84 252.04 101.84 252.04 101.82 252.04C101.4 251.93 100.96 252.32 101.23 252.63C101.97 253.23 104.55 253.81 107.06 253.72C110.75 253.76 114.17 253.48 117.5 252.83C118.66 252.58 119.87 252.41 121.01 252.12C121.26 251.98 121.04 251.64 120.73 251.72L120.72 251.71Z"
        fill="url(#paint152_linear_1_2)"
      />
      <path
        d="M189.01 157.63C188.87 157.28 189.07 157.02 188.76 156.8C188.62 156.7 188.4 156.66 188.21 156.7C187.55 156.86 187.85 157.46 187.76 157.84C187.71 159.1 187.76 160.36 187.76 161.62C187.91 165.2 187.45 169.16 186.89 172.14C185.7 179.58 181.8 186.93 178.27 194.54C174.88 202.3 170.01 209.28 164.66 216.56C161.57 220.44 157.7 223.98 154.29 227.72C149.61 232.71 144.89 237.73 138.89 242C135.77 244.39 127.55 247.21 123.82 249.1C123.62 249.25 123.25 249.29 123.18 249.49C123.18 249.57 123.32 249.61 123.41 249.57C129.29 246.44 139.96 242.44 144.35 238.22C150.39 232.03 156.74 226 162.69 219.76C165.84 216.27 169.01 212.77 171.56 209.04C174.69 204.2 177.38 198.58 180.24 193.03C184.38 184.65 188.75 177.64 188.59 168.99C188.81 165.22 189.58 161.43 189 157.65L189.01 157.63Z"
        fill="url(#paint153_linear_1_2)"
      />
      <path
        d="M185.94 159.16C185.81 158.63 185.87 158.28 185.72 158.04C185.59 157.79 185.16 157.65 184.79 157.72C184.32 157.81 184.14 158.16 184.24 158.47C184.29 159.06 184.35 159.65 184.39 160.25C184.51 162.79 184.42 165.33 184.09 167.86C183.42 172.97 181.58 178.77 179.76 184.29C177.4 191.45 174.26 198.11 170.39 204.58C163.43 216.1 153.4 226.86 142.67 236.69C155.21 225.62 167.05 213.67 173.8 200.26C177.56 193.12 180.96 187.01 183.3 179.58C184.71 174.89 186.14 170.15 186.28 165.34C186.29 163.28 186.19 161.22 185.94 159.16Z"
        fill="url(#paint154_linear_1_2)"
      />
      <path
        d="M167.07 200.06C164.83 204.53 162.74 208.79 159.7 213.34C158.29 215.45 156.85 217.55 155.23 219.55C154.58 220.36 153.9 221.16 153.24 221.96C153.22 222.03 153.35 222.06 153.39 222C156.94 217.72 160.48 213.41 163.36 208.81C168.54 200.17 172.94 192.37 175.97 183.09"
        fill="url(#paint155_linear_1_2)"
      />
      <path
        d="M169.9 181.84C167.85 189.15 165.2 195.17 162.2 202.26C160.61 205.68 158.9 209.06 157.09 212.38C156.23 213.94 155.33 215.48 154.41 217.02C154.37 217.08 154.48 217.13 154.52 217.07C161.28 206.37 166.47 196.25 170.5 184.7C172.4 179.08 173.6 173.24 174.3 167.95"
        fill="url(#paint156_linear_1_2)"
      />
      <path
        d="M169 168.1C168.11 176.05 166.39 182.43 163.99 190.75C162.75 194.84 161.01 198.81 159.24 202.76C158.96 203.48 158.45 204.18 158.27 204.9C158.32 204.98 158.49 204.96 158.52 204.87C160.17 201.15 162.06 197.5 163.55 193.73C165.65 188.19 167.33 183.71 168.76 178.04"
        fill="url(#paint157_linear_1_2)"
      />
      <path
        d="M161.04 190.36C160.72 191.56 160.24 192.74 159.91 193.94C159.91 194.05 160.14 194.07 160.17 193.95"
        fill="url(#paint158_linear_1_2)"
      />
      <path
        d="M98.56 248.38C107.77 251 117.84 249.01 124.64 243.91C126.5 242.66 132.57 240.58 134.21 239.16C134.27 239.09 134.38 239.04 134.39 238.96C134.39 238.88 134.26 238.84 134.19 238.9C129.12 243.33 118.3 247.06 111.12 248.62C107.11 249.54 103.04 249.28 99.11 248.28"
        fill="url(#paint159_linear_1_2)"
      />
      <path
        d="M146.82 226.66C146.74 226.64 146.66 226.66 146.62 226.72C141.72 232.02 136.07 236.71 129.07 240.04C124.19 242.47 114.8 244.95 109.61 245.14C108.75 245.2 107.88 245.18 107.02 245.24C106.8 245.3 106.78 245.56 106.98 245.64C107.53 245.73 108.13 245.69 108.69 245.73C113.71 246 118.5 244.67 122.97 242.59C127.45 240.56 135.91 237.33 139.24 234.25C141.8 232.09 143.98 229.69 146.35 227.4C146.57 227.11 147.17 226.84 146.81 226.66H146.82Z"
        fill="url(#paint160_linear_1_2)"
      />
      <path
        d="M149.7 220.45C147.22 223.07 144.85 225.59 142.01 227.99C139.59 230.04 136.84 231.84 134.15 233.67C130.03 236.29 126.54 238.5 121.49 240.53V240.52C121.27 240.62 116.58 241.42 116.64 241.67C116.72 241.99 117.16 241.92 117.33 241.84C117.43 241.81 117.49 241.8 117.52 241.78C118.18 241.57 123.17 240.63 123.83 240.41C125.71 239.75 127.49 238.93 129.12 237.95C132.68 235.86 135.9 233.45 139.06 231.01C142.24 228.65 144.91 225.94 147.43 223.16C148.23 222.26 149.18 221.4 149.9 220.47C149.88 220.4 149.75 220.39 149.71 220.45H149.7Z"
        fill="url(#paint161_linear_1_2)"
      />
      <path
        d="M155.92 208.91C152.76 215 147.75 219.93 142.31 224.73C136.79 229.49 132.12 233.14 125.34 236.2C124.67 236.49 124.12 236.66 123.52 236.86C123.37 236.94 123.42 237.14 123.6 237.17C124.12 237.12 124.62 236.91 125.12 236.77C131.24 234.65 136.32 231 140.82 227.12C144.29 224.17 147.45 221.11 150.25 217.82C152.36 215.27 154.17 212.56 155.73 209.77C155.84 209.47 156.16 209.16 156.12 208.89C156.07 208.85 155.98 208.86 155.94 208.91H155.92Z"
        fill="url(#paint162_linear_1_2)"
      />
      <path
        d="M158.39 199.73C151.74 211.51 142.39 222.9 129.05 229.86C128.56 230.16 127.77 230.35 127.41 230.71C127.36 231.42 128.71 230.56 129.14 230.47C138.95 226.39 145.87 218.74 151.47 211C153.99 207.63 156.23 204.12 158.33 200.57C158.45 200.3 158.7 200.06 158.74 199.78C158.7 199.66 158.47 199.63 158.39 199.74V199.73Z"
        fill="url(#paint163_linear_1_2)"
      />
      <path
        d="M159.37 187.18C156.88 194.24 153.22 200.74 148.52 207.05C144.14 213.14 139.4 218.37 133 223.16C132.68 223.47 132.05 223.74 131.93 224.11C132.16 224.88 133.11 223.9 133.43 223.76C139.18 220.05 143.68 215.26 147.5 210.23C151.32 205.1 154.37 200.12 156.74 194.46C157.78 192.14 158.71 189.78 159.55 187.4C159.57 187.32 159.65 187.24 159.6 187.16C159.55 187.08 159.39 187.1 159.37 187.18Z"
        fill="url(#paint164_linear_1_2)"
      />
      <path
        d="M157.46 183.62C157.2 183.89 157.25 184.32 157.11 184.64C156.04 188.74 154.17 191.8 152.17 195.39C150.43 198.61 148.65 201.83 146.38 204.84C143.58 208.5 140.24 212.2 137.14 215.53C136.48 216.23 135.76 216.89 135.09 217.58C135.04 217.67 135.2 217.76 135.29 217.69C140.4 213.17 145.01 208.47 148.69 203.06C152.47 196.76 155.94 191.42 157.66 184.54C157.72 184.28 157.8 184.02 157.82 183.76C157.81 183.63 157.6 183.55 157.46 183.62Z"
        fill="url(#paint165_linear_1_2)"
      />
      <path
        d="M142.97 204.66C141.97 206.25 140.76 207.75 139.67 209.3C139.65 209.39 139.82 209.44 139.87 209.36"
        fill="url(#paint166_linear_1_2)"
      />
      <path
        d="M46.74 97.21C42.58 100.77 37.92 104.13 35.36 108.87C33.18 112.43 31.83 116.32 30.25 120.11C29.86 121.09 29.39 122.07 29.09 123.07C29.11 123.24 29.41 123.27 29.46 123.09C31.74 117.25 33.8 111.46 37.72 106.34C39.99 103.58 43.25 100.84 46.11 98.26C46.5 97.86 47.07 97.54 47.37 97.09C47.27 96.72 46.93 97.06 46.75 97.21H46.74Z"
        fill="url(#paint167_linear_1_2)"
      />
      <path
        d="M42.02 104.08C38.46 106.95 36.45 110.64 34.73 114.45C33.86 116.39 32.81 118.29 32.07 120.3C32.03 120.44 32.28 120.51 32.32 120.36C34.62 114.85 37.69 108.99 41.88 104.6C42 104.44 42.2 104.31 42.25 104.15C42.25 104.04 42.09 103.99 42.01 104.08H42.02Z"
        fill="url(#paint168_linear_1_2)"
      />
      <path
        d="M40.6 108.72C40.13 109.14 39.47 109.62 39.22 110.01C37.77 112.11 36.97 114.52 36.08 116.85C36.01 117.08 36.42 117.16 36.46 116.92C37.56 114.3 38.4 111.91 40.09 109.56C40.15 109.45 40.4 109.15 40.55 108.98C40.6 108.9 40.73 108.84 40.71 108.74C40.69 108.7 40.63 108.69 40.6 108.72Z"
        fill="url(#paint169_linear_1_2)"
      />
      <path
        d="M40.67 111.98C39.91 113.4 39.11 114.82 38.58 116.33C38.53 116.43 38.51 116.59 38.68 116.6C38.93 116.52 38.93 116.05 39.07 115.85C39.35 115.24 39.77 114.42 40.14 113.71C40.42 113.16 40.74 112.63 41.02 112.09C41.06 111.91 40.77 111.82 40.67 111.98Z"
        fill="url(#paint170_linear_1_2)"
      />
      <path
        d="M42.77 112.8C42.1 114.03 41.45 115.28 40.95 116.57C40.95 116.65 41.08 116.69 41.15 116.63C41.7 115.52 42.25 114.19 42.89 112.97C43.01 112.83 42.91 112.67 42.77 112.79V112.8Z"
        fill="url(#paint171_linear_1_2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.51 161.27H208V168.83H199.51V161.27ZM208.17 139.34H223.23V152.75H208.17V139.34ZM195.54 133.16H204.03V140.72H195.54V133.16Z"
        fill="#D81E40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.16 172.67H20.28V179.01H13.16V172.67ZM16.03 142.82H22.73C22.96 142.82 23.15 142.99 23.15 143.2V148.78C23.15 148.99 22.96 149.16 22.73 149.16H16.46C16.23 149.16 16.04 148.99 16.04 148.78V142.82H16.03ZM0 153.2H12.95V164.73H0V153.2Z"
        fill="#224290"
      />
      <path
        d="M81.85 219.12C77.5 219.12 73.97 216.18 73.97 212.57V126.26C73.97 124.65 72.39 123.34 70.46 123.34C68.53 123.34 66.95 124.65 66.95 126.26V181.83C66.95 185.44 63.41 188.38 59.07 188.38C54.73 188.38 51.19 185.44 51.19 181.83V146.75C51.19 145.14 49.61 143.83 47.68 143.83C45.75 143.83 44.17 145.14 44.17 146.75V158.28C44.17 161.13 41.38 163.44 37.96 163.44H29.58C28.37 163.44 27.39 162.63 27.39 161.62C27.39 160.61 28.37 159.8 29.58 159.8H37.96C38.98 159.8 39.8 159.11 39.8 158.27V146.74C39.8 143.13 43.34 140.19 47.68 140.19C52.02 140.19 55.56 143.13 55.56 146.74V181.82C55.56 183.43 57.14 184.74 59.07 184.74C61 184.74 62.58 183.43 62.58 181.82V126.25C62.58 122.64 66.12 119.7 70.46 119.7C74.8 119.7 78.34 122.64 78.34 126.25V212.56C78.34 214.17 79.92 215.48 81.85 215.48C83.78 215.48 85.36 214.17 85.36 212.56V118.34C85.36 114.73 88.9 111.79 93.24 111.79C97.58 111.79 101.12 114.73 101.12 118.34V189.43C101.12 191.04 102.7 192.35 104.63 192.35C106.56 192.35 108.14 191.04 108.14 189.43V118.34C108.14 114.73 111.68 111.79 116.02 111.79C120.36 111.79 123.9 114.73 123.9 118.34V186.34C123.9 187.95 125.48 189.26 127.41 189.26C129.34 189.26 130.92 187.95 130.92 186.34V124.7C130.92 121.09 134.46 118.15 138.8 118.15C143.14 118.15 146.68 121.09 146.68 124.7V172.51C146.68 174.12 148.26 175.43 150.19 175.43C152.12 175.43 153.7 174.12 153.7 172.51V136.96C153.7 133.35 157.24 130.41 161.58 130.41C165.92 130.41 169.46 133.35 169.46 136.96V160.4C169.46 162.01 171.04 163.32 172.97 163.32C174.9 163.32 176.48 162.01 176.48 160.4V155.55C176.48 152.7 179.27 150.39 182.69 150.39H190.75C191.96 150.39 192.94 151.2 192.94 152.21C192.94 153.22 191.96 154.03 190.75 154.03H182.69C181.67 154.03 180.85 154.72 180.85 155.56V160.41C180.85 164.02 177.31 166.96 172.97 166.96C168.63 166.96 165.09 164.02 165.09 160.41V136.97C165.09 135.36 163.51 134.05 161.58 134.05C159.65 134.05 158.07 135.36 158.07 136.97V172.52C158.07 176.13 154.53 179.07 150.19 179.07C145.85 179.07 142.31 176.13 142.31 172.52V124.71C142.31 123.1 140.73 121.79 138.8 121.79C136.87 121.79 135.29 123.1 135.29 124.71V186.35C135.29 189.96 131.75 192.9 127.41 192.9C123.07 192.9 119.53 189.96 119.53 186.35V118.35C119.53 116.74 117.95 115.43 116.02 115.43C114.09 115.43 112.51 116.74 112.51 118.35V189.44C112.51 193.05 108.97 195.99 104.63 195.99C100.29 195.99 96.75 193.05 96.75 189.44V118.35C96.75 116.74 95.17 115.43 93.24 115.43C91.31 115.43 89.73 116.74 89.73 118.35V212.57C89.73 216.18 86.19 219.12 81.85 219.12Z"
        fill="url(#paint172_linear_1_2)"
      />
      <path
        d="M204.25 154.34C203.01 157.09 199.49 158.43 196.4 157.32C193.31 156.21 191.81 153.08 193.05 150.33C194.29 147.58 197.81 146.24 200.9 147.35C203.99 148.46 205.49 151.59 204.25 154.34Z"
        stroke="#0084C0"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M28.75 163.6C27.51 166.35 23.99 167.69 20.9 166.58C17.81 165.47 16.31 162.34 17.55 159.59C18.79 156.84 22.31 155.5 25.4 156.61C28.49 157.72 29.99 160.85 28.75 163.6Z"
        stroke="#FDC01E"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_2"
        x1="196.27"
        y1="66.96"
        x2="203.76"
        y2="66.96"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_2"
        x1="72.34"
        y1="31.84"
        x2="72.9"
        y2="31.84"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_2"
        x1="70.48"
        y1="51.06"
        x2="72.81"
        y2="51.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_2"
        x1="73.11"
        y1="42.98"
        x2="76.33"
        y2="42.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1_2"
        x1="70.63"
        y1="44.09"
        x2="74.73"
        y2="44.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1_2"
        x1="63.6"
        y1="61.44"
        x2="70.74"
        y2="61.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1_2"
        x1="69.67"
        y1="33.13"
        x2="70.42"
        y2="33.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1_2"
        x1="60.84"
        y1="60.15"
        x2="63.75"
        y2="60.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1_2"
        x1="30.85"
        y1="75.5"
        x2="48.37"
        y2="75.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1_2"
        x1="40.59"
        y1="69.02"
        x2="49.93"
        y2="69.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1_2"
        x1="61.35"
        y1="56.65"
        x2="61.93"
        y2="56.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1_2"
        x1="58.05"
        y1="74.09"
        x2="61.26"
        y2="74.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1_2"
        x1="41.14"
        y1="77.55"
        x2="51.67"
        y2="77.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1_2"
        x1="56.22"
        y1="75.91"
        x2="59.56"
        y2="75.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1_2"
        x1="53.71"
        y1="78.64"
        x2="57.22"
        y2="78.64"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1_2"
        x1="35.66"
        y1="100.54"
        x2="39.9"
        y2="100.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1_2"
        x1="44.17"
        y1="80.8"
        x2="52.69"
        y2="80.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1_2"
        x1="50.81"
        y1="81.65"
        x2="55.01"
        y2="81.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1_2"
        x1="46.46"
        y1="85.81"
        x2="52.22"
        y2="85.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1_2"
        x1="112.4"
        y1="71.2"
        x2="136.33"
        y2="71.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1_2"
        x1="128.89"
        y1="56.05"
        x2="130.18"
        y2="56.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1_2"
        x1="98.41"
        y1="72.6"
        x2="134.07"
        y2="72.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1_2"
        x1="109.61"
        y1="55.91"
        x2="112.62"
        y2="55.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1_2"
        x1="79.12"
        y1="44.99"
        x2="83.07"
        y2="44.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_1_2"
        x1="84.89"
        y1="29.88"
        x2="119.38"
        y2="29.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_1_2"
        x1="96.68"
        y1="85.28"
        x2="101.26"
        y2="85.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_1_2"
        x1="77.13"
        y1="50.97"
        x2="78.24"
        y2="50.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_1_2"
        x1="85.24"
        y1="39.48"
        x2="86.6"
        y2="39.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_1_2"
        x1="68.34"
        y1="75.85"
        x2="86.94"
        y2="75.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_1_2"
        x1="80"
        y1="51.42"
        x2="80.84"
        y2="51.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_1_2"
        x1="77.06"
        y1="87"
        x2="88.52"
        y2="87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_1_2"
        x1="94.88"
        y1="89.21"
        x2="99.08"
        y2="89.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_1_2"
        x1="79.33"
        y1="88.44"
        x2="90.51"
        y2="88.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_1_2"
        x1="92.8"
        y1="92.92"
        x2="96.74"
        y2="92.92"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_1_2"
        x1="90.98"
        y1="97.7"
        x2="95.29"
        y2="97.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_1_2"
        x1="84.9"
        y1="95.39"
        x2="92.34"
        y2="95.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_1_2"
        x1="88.73"
        y1="97.18"
        x2="93.96"
        y2="97.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_1_2"
        x1="88.63"
        y1="29.81"
        x2="130.2"
        y2="29.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_1_2"
        x1="82.79"
        y1="35.27"
        x2="124.23"
        y2="35.27"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_1_2"
        x1="77.73"
        y1="45.46"
        x2="117.47"
        y2="45.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_1_2"
        x1="79.53"
        y1="49.45"
        x2="108.98"
        y2="49.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint41_linear_1_2"
        x1="82.67"
        y1="48.44"
        x2="100.02"
        y2="48.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint42_linear_1_2"
        x1="88.73"
        y1="46.79"
        x2="98.88"
        y2="46.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint43_linear_1_2"
        x1="136.68"
        y1="56.4"
        x2="163.27"
        y2="56.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint44_linear_1_2"
        x1="130.96"
        y1="57.49"
        x2="160.11"
        y2="57.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint45_linear_1_2"
        x1="115.3"
        y1="54.04"
        x2="170.26"
        y2="54.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint46_linear_1_2"
        x1="126.68"
        y1="47.18"
        x2="133.1"
        y2="47.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint47_linear_1_2"
        x1="140.44"
        y1="42.37"
        x2="185.08"
        y2="42.37"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint48_linear_1_2"
        x1="153.19"
        y1="31.09"
        x2="155.98"
        y2="31.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint49_linear_1_2"
        x1="144.96"
        y1="44.72"
        x2="145.49"
        y2="44.72"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint50_linear_1_2"
        x1="171.79"
        y1="58.05"
        x2="175.34"
        y2="58.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint51_linear_1_2"
        x1="166.53"
        y1="50.62"
        x2="181.43"
        y2="50.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint52_linear_1_2"
        x1="148.14"
        y1="53.31"
        x2="174.17"
        y2="53.31"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint53_linear_1_2"
        x1="146.45"
        y1="19.42"
        x2="155.13"
        y2="19.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint54_linear_1_2"
        x1="144.95"
        y1="19.65"
        x2="151.66"
        y2="19.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint55_linear_1_2"
        x1="143.46"
        y1="20.02"
        x2="148.36"
        y2="20.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint56_linear_1_2"
        x1="144.54"
        y1="23.64"
        x2="144.56"
        y2="23.64"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint57_linear_1_2"
        x1="143.57"
        y1="20.31"
        x2="144.12"
        y2="20.31"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint58_linear_1_2"
        x1="133.95"
        y1="14.47"
        x2="149.3"
        y2="14.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint59_linear_1_2"
        x1="135.81"
        y1="16.96"
        x2="145.22"
        y2="16.96"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint60_linear_1_2"
        x1="137.38"
        y1="19.66"
        x2="141.52"
        y2="19.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint61_linear_1_2"
        x1="130.62"
        y1="12.21"
        x2="134.88"
        y2="12.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint62_linear_1_2"
        x1="133.67"
        y1="18.61"
        x2="133.77"
        y2="18.61"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint63_linear_1_2"
        x1="133.63"
        y1="18.66"
        x2="133.67"
        y2="18.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint64_linear_1_2"
        x1="128.93"
        y1="20.87"
        x2="128.96"
        y2="20.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint65_linear_1_2"
        x1="128.86"
        y1="13.79"
        x2="130.56"
        y2="13.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint66_linear_1_2"
        x1="117.23"
        y1="12.1"
        x2="124.08"
        y2="12.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint67_linear_1_2"
        x1="183.71"
        y1="97.71"
        x2="201.55"
        y2="97.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint68_linear_1_2"
        x1="185.63"
        y1="104.78"
        x2="211.57"
        y2="104.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint69_linear_1_2"
        x1="182.62"
        y1="97.97"
        x2="186.54"
        y2="97.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint70_linear_1_2"
        x1="180.87"
        y1="95.77"
        x2="185.08"
        y2="95.77"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint71_linear_1_2"
        x1="179.51"
        y1="96.13"
        x2="183.41"
        y2="96.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint72_linear_1_2"
        x1="178.16"
        y1="96.29"
        x2="180.98"
        y2="96.29"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint73_linear_1_2"
        x1="176.02"
        y1="95.31"
        x2="178.35"
        y2="95.31"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint74_linear_1_2"
        x1="203.59"
        y1="98.51"
        x2="205.41"
        y2="98.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint75_linear_1_2"
        x1="189.87"
        y1="113.93"
        x2="189.99"
        y2="113.93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint76_linear_1_2"
        x1="188.77"
        y1="117.68"
        x2="209.07"
        y2="117.68"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint77_linear_1_2"
        x1="189.06"
        y1="113.67"
        x2="208.42"
        y2="113.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint78_linear_1_2"
        x1="189.85"
        y1="119"
        x2="198.8"
        y2="119"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint79_linear_1_2"
        x1="190.32"
        y1="121.12"
        x2="198.83"
        y2="121.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint80_linear_1_2"
        x1="80.16"
        y1="26.5"
        x2="85.39"
        y2="26.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint81_linear_1_2"
        x1="81.9"
        y1="27.12"
        x2="86.65"
        y2="27.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint82_linear_1_2"
        x1="83.95"
        y1="27.02"
        x2="88.31"
        y2="27.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint83_linear_1_2"
        x1="86.38"
        y1="26.43"
        x2="89.48"
        y2="26.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint84_linear_1_2"
        x1="88.96"
        y1="26.35"
        x2="92.2"
        y2="26.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint85_linear_1_2"
        x1="91.88"
        y1="24.6"
        x2="93.58"
        y2="24.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint86_linear_1_2"
        x1="94.44"
        y1="22.84"
        x2="95.6"
        y2="22.84"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint87_linear_1_2"
        x1="95.53"
        y1="17.98"
        x2="102.53"
        y2="17.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint88_linear_1_2"
        x1="96.98"
        y1="21.02"
        x2="100.65"
        y2="21.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint89_linear_1_2"
        x1="96.52"
        y1="22.79"
        x2="99.41"
        y2="22.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint90_linear_1_2"
        x1="139.24"
        y1="94.63"
        x2="194.36"
        y2="94.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint91_linear_1_2"
        x1="141.13"
        y1="93.07"
        x2="188.05"
        y2="93.07"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint92_linear_1_2"
        x1="134.73"
        y1="108.91"
        x2="138.79"
        y2="108.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint93_linear_1_2"
        x1="132.91"
        y1="96.46"
        x2="174.89"
        y2="96.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint94_linear_1_2"
        x1="140.74"
        y1="90.53"
        x2="166"
        y2="90.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint95_linear_1_2"
        x1="124.29"
        y1="97.63"
        x2="163.75"
        y2="97.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint96_linear_1_2"
        x1="127.32"
        y1="94.61"
        x2="155.24"
        y2="94.61"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint97_linear_1_2"
        x1="123.54"
        y1="94.9"
        x2="145.94"
        y2="94.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint98_linear_1_2"
        x1="85.78"
        y1="93.24"
        x2="124.19"
        y2="93.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint99_linear_1_2"
        x1="89.15"
        y1="93.23"
        x2="125.44"
        y2="93.23"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint100_linear_1_2"
        x1="90.46"
        y1="95.07"
        x2="126.73"
        y2="95.07"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint101_linear_1_2"
        x1="94.43"
        y1="99.54"
        x2="121.18"
        y2="99.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint102_linear_1_2"
        x1="96.16"
        y1="103.57"
        x2="112.73"
        y2="103.57"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint103_linear_1_2"
        x1="97.75"
        y1="106.38"
        x2="106.92"
        y2="106.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint104_linear_1_2"
        x1="125.79"
        y1="60.48"
        x2="194.63"
        y2="60.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint105_linear_1_2"
        x1="184.07"
        y1="59.62"
        x2="192.9"
        y2="59.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint106_linear_1_2"
        x1="124.52"
        y1="63.88"
        x2="182.15"
        y2="63.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint107_linear_1_2"
        x1="122.44"
        y1="65.52"
        x2="166.55"
        y2="65.52"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint108_linear_1_2"
        x1="120.19"
        y1="66.94"
        x2="155.72"
        y2="66.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint109_linear_1_2"
        x1="120.54"
        y1="66.08"
        x2="120.61"
        y2="66.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint110_linear_1_2"
        x1="120.48"
        y1="66.06"
        x2="120.54"
        y2="66.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint111_linear_1_2"
        x1="118.38"
        y1="68.84"
        x2="142.8"
        y2="68.84"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint112_linear_1_2"
        x1="114.97"
        y1="78.94"
        x2="114.99"
        y2="78.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint113_linear_1_2"
        x1="114.96"
        y1="77.35"
        x2="121.04"
        y2="77.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint114_linear_1_2"
        x1="116.26"
        y1="79.45"
        x2="116.28"
        y2="79.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint115_linear_1_2"
        x1="116.23"
        y1="79.5"
        x2="116.26"
        y2="79.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint116_linear_1_2"
        x1="67.33"
        y1="99.19"
        x2="76.5"
        y2="99.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint117_linear_1_2"
        x1="65.51"
        y1="97.34"
        x2="71.64"
        y2="97.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint118_linear_1_2"
        x1="63.68"
        y1="96.06"
        x2="68.51"
        y2="96.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint119_linear_1_2"
        x1="68.49"
        y1="101.72"
        x2="68.51"
        y2="101.72"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint120_linear_1_2"
        x1="62.3"
        y1="96.02"
        x2="66.19"
        y2="96.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint121_linear_1_2"
        x1="60.43"
        y1="95.74"
        x2="63.53"
        y2="95.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint122_linear_1_2"
        x1="58.24"
        y1="92.7"
        x2="59.1"
        y2="92.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint123_linear_1_2"
        x1="27.23"
        y1="139.88"
        x2="30.53"
        y2="139.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint124_linear_1_2"
        x1="29.52"
        y1="143.36"
        x2="32.84"
        y2="143.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint125_linear_1_2"
        x1="77.26"
        y1="110.22"
        x2="79.68"
        y2="110.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint126_linear_1_2"
        x1="72.22"
        y1="108.85"
        x2="77.7"
        y2="108.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint127_linear_1_2"
        x1="69.04"
        y1="107.6"
        x2="75.05"
        y2="107.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint128_linear_1_2"
        x1="171.58"
        y1="113.94"
        x2="190.19"
        y2="113.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint129_linear_1_2"
        x1="170.09"
        y1="111.78"
        x2="188.06"
        y2="111.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint130_linear_1_2"
        x1="167.26"
        y1="107.16"
        x2="185.87"
        y2="107.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint131_linear_1_2"
        x1="162.86"
        y1="105.67"
        x2="182.98"
        y2="105.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint132_linear_1_2"
        x1="160.4"
        y1="104.73"
        x2="178.36"
        y2="104.73"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint133_linear_1_2"
        x1="155.98"
        y1="103.94"
        x2="171.98"
        y2="103.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint134_linear_1_2"
        x1="167.38"
        y1="107.17"
        x2="167.52"
        y2="107.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint135_linear_1_2"
        x1="157.02"
        y1="103.06"
        x2="159.52"
        y2="103.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint136_linear_1_2"
        x1="189.22"
        y1="139.49"
        x2="190.65"
        y2="139.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint137_linear_1_2"
        x1="187.05"
        y1="140.17"
        x2="188.42"
        y2="140.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint138_linear_1_2"
        x1="80.37"
        y1="12.05"
        x2="94.67"
        y2="12.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint139_linear_1_2"
        x1="120.4"
        y1="0.85"
        x2="132.48"
        y2="0.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint140_linear_1_2"
        x1="131.56"
        y1="0.290009"
        x2="131.63"
        y2="0.290009"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint141_linear_1_2"
        x1="152.15"
        y1="7.79999"
        x2="158.21"
        y2="7.79999"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint142_linear_1_2"
        x1="197.02"
        y1="67.18"
        x2="202.6"
        y2="67.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint143_linear_1_2"
        x1="33.39"
        y1="189.33"
        x2="51.92"
        y2="189.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint144_linear_1_2"
        x1="37.26"
        y1="184.56"
        x2="44.74"
        y2="184.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint145_linear_1_2"
        x1="38.32"
        y1="174.14"
        x2="41.85"
        y2="174.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint146_linear_1_2"
        x1="40.03"
        y1="168.43"
        x2="41.89"
        y2="168.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint147_linear_1_2"
        x1="45.42"
        y1="221.57"
        x2="96.75"
        y2="221.57"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint148_linear_1_2"
        x1="42.7"
        y1="214.13"
        x2="94.78"
        y2="214.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint149_linear_1_2"
        x1="42.22"
        y1="199.52"
        x2="74.04"
        y2="199.52"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint150_linear_1_2"
        x1="43.3"
        y1="193.7"
        x2="73.57"
        y2="193.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint151_linear_1_2"
        x1="56.73"
        y1="202.01"
        x2="69.21"
        y2="202.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint152_linear_1_2"
        x1="101.13"
        y1="252.71"
        x2="121.1"
        y2="252.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint153_linear_1_2"
        x1="123.18"
        y1="203.12"
        x2="189.22"
        y2="203.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint154_linear_1_2"
        x1="142.67"
        y1="197.2"
        x2="186.29"
        y2="197.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint155_linear_1_2"
        x1="153.23"
        y1="202.56"
        x2="175.95"
        y2="202.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint156_linear_1_2"
        x1="154.4"
        y1="192.54"
        x2="174.3"
        y2="192.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint157_linear_1_2"
        x1="158.26"
        y1="186.52"
        x2="169"
        y2="186.52"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint158_linear_1_2"
        x1="159.91"
        y1="192.19"
        x2="161.04"
        y2="192.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint159_linear_1_2"
        x1="98.56"
        y1="244.2"
        x2="134.4"
        y2="244.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint160_linear_1_2"
        x1="106.85"
        y1="236.21"
        x2="146.94"
        y2="236.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint161_linear_1_2"
        x1="116.64"
        y1="231.16"
        x2="149.89"
        y2="231.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint162_linear_1_2"
        x1="123.42"
        y1="223.02"
        x2="156.1"
        y2="223.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint163_linear_1_2"
        x1="127.4"
        y1="215.32"
        x2="158.74"
        y2="215.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint164_linear_1_2"
        x1="131.93"
        y1="205.75"
        x2="159.62"
        y2="205.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint165_linear_1_2"
        x1="135.09"
        y1="200.66"
        x2="157.82"
        y2="200.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint166_linear_1_2"
        x1="139.67"
        y1="207.02"
        x2="142.97"
        y2="207.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint167_linear_1_2"
        x1="29.08"
        y1="110.07"
        x2="47.36"
        y2="110.07"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint168_linear_1_2"
        x1="32.07"
        y1="112.24"
        x2="42.26"
        y2="112.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint169_linear_1_2"
        x1="36.07"
        y1="112.88"
        x2="40.72"
        y2="112.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint170_linear_1_2"
        x1="38.55"
        y1="114.24"
        x2="41.02"
        y2="114.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint171_linear_1_2"
        x1="40.95"
        y1="114.71"
        x2="42.94"
        y2="114.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <linearGradient
        id="paint172_linear_1_2"
        x1="193"
        y1="165.46"
        x2="27.36"
        y2="165.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#1B83C6" />
        <stop offset="0.28" stopColor="#7B72A3" />
        <stop offset="0.51" stopColor="#E82888" />
        <stop offset="0.77" stopColor="#F16873" />
        <stop offset="1" stopColor="#F5BC52" />
      </linearGradient>
      <clipPath id="clip0_1_2">
        <rect width="223.22" height="253.72" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AdminIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <g clipPath="url(#clip0_401_23577)">
      <path
        d="M27 18.9996C27.34 18.9996 27.67 19.0396 28 19.0896V15.5796C28 14.7796 27.53 14.0596 26.8 13.7496L21.3 11.3496C20.79 11.1296 20.21 11.1296 19.7 11.3496L14.2 13.7496C13.47 14.0696 13 14.7896 13 15.5796V19.1796C13 23.7196 16.2 27.9696 20.5 28.9996C21.05 28.8696 21.58 28.6796 22.1 28.4496C21.41 27.4696 21 26.2796 21 24.9996C21 21.6896 23.69 18.9996 27 18.9996Z"
        fill="white"
      />
      <path
        d="M27 21C24.79 21 23 22.79 23 25C23 27.21 24.79 29 27 29C29.21 29 31 27.21 31 25C31 22.79 29.21 21 27 21ZM27 22.38C27.62 22.38 28.12 22.89 28.12 23.5C28.12 24.11 27.61 24.62 27 24.62C26.39 24.62 25.88 24.11 25.88 23.5C25.88 22.89 26.38 22.38 27 22.38ZM27 27.75C26.07 27.75 25.26 27.29 24.76 26.58C24.81 25.86 26.27 25.5 27 25.5C27.73 25.5 29.19 25.86 29.24 26.58C28.74 27.29 27.93 27.75 27 27.75Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_401_23577">
        <rect width="24" height="24" fill="white" transform="translate(10 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const ChatBotIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <g clipPath="url(#clip0_401_23571)">
      <path
        d="M30 14H29V22C29 22.55 28.55 23 28 23H16V24C16 25.1 16.9 26 18 26H28L32 30V16C32 14.9 31.1 14 30 14ZM27 19V12C27 10.9 26.1 10 25 10H14C12.9 10 12 10.9 12 12V25L16 21H25C26.1 21 27 20.1 27 19Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_401_23571">
        <rect width="24" height="24" fill="white" transform="translate(10 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const DashboardIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <path
      d="M16.0016 11.5996C15.365 11.5996 14.7546 11.8525 14.3045 12.3026C13.8544 12.7526 13.6016 13.3631 13.6016 13.9996V16.3996C13.6016 17.0361 13.8544 17.6466 14.3045 18.0967C14.7546 18.5468 15.365 18.7996 16.0016 18.7996H18.4016C19.0381 18.7996 19.6485 18.5468 20.0986 18.0967C20.5487 17.6466 20.8016 17.0361 20.8016 16.3996V13.9996C20.8016 13.3631 20.5487 12.7526 20.0986 12.3026C19.6485 11.8525 19.0381 11.5996 18.4016 11.5996H16.0016ZM16.0016 21.1996C15.365 21.1996 14.7546 21.4525 14.3045 21.9026C13.8544 22.3526 13.6016 22.9631 13.6016 23.5996V25.9996C13.6016 26.6361 13.8544 27.2466 14.3045 27.6967C14.7546 28.1468 15.365 28.3996 16.0016 28.3996H18.4016C19.0381 28.3996 19.6485 28.1468 20.0986 27.6967C20.5487 27.2466 20.8016 26.6361 20.8016 25.9996V23.5996C20.8016 22.9631 20.5487 22.3526 20.0986 21.9026C19.6485 21.4525 19.0381 21.1996 18.4016 21.1996H16.0016ZM23.2016 13.9996C23.2016 13.3631 23.4544 12.7526 23.9045 12.3026C24.3546 11.8525 24.965 11.5996 25.6016 11.5996H28.0016C28.6381 11.5996 29.2485 11.8525 29.6986 12.3026C30.1487 12.7526 30.4016 13.3631 30.4016 13.9996V16.3996C30.4016 17.0361 30.1487 17.6466 29.6986 18.0967C29.2485 18.5468 28.6381 18.7996 28.0016 18.7996H25.6016C24.965 18.7996 24.3546 18.5468 23.9045 18.0967C23.4544 17.6466 23.2016 17.0361 23.2016 16.3996V13.9996ZM23.2016 23.5996C23.2016 22.9631 23.4544 22.3526 23.9045 21.9026C24.3546 21.4525 24.965 21.1996 25.6016 21.1996H28.0016C28.6381 21.1996 29.2485 21.4525 29.6986 21.9026C30.1487 22.3526 30.4016 22.9631 30.4016 23.5996V25.9996C30.4016 26.6361 30.1487 27.2466 29.6986 27.6967C29.2485 28.1468 28.6381 28.3996 28.0016 28.3996H25.6016C24.965 28.3996 24.3546 28.1468 23.9045 27.6967C23.4544 27.2466 23.2016 26.6361 23.2016 25.9996V23.5996Z"
      fill="white"
    />
  </svg>
);

export const ParticipantIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <g clipPath="url(#clip0_401_23565)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6719 21.1299C28.0419 22.0599 29.0019 23.3199 29.0019 24.9999V27.9999H32.0019C32.5519 27.9999 33.0019 27.5499 33.0019 26.9999V24.9999C33.0019 22.8199 29.4319 21.5299 26.6719 21.1299Z"
        fill="white"
      />
      <path
        d="M19 20C21.2091 20 23 18.2091 23 16C23 13.7909 21.2091 12 19 12C16.7909 12 15 13.7909 15 16C15 18.2091 16.7909 20 19 20Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0019 20C27.2119 20 29.0019 18.21 29.0019 16C29.0019 13.79 27.2119 12 25.0019 12C24.5319 12 24.0919 12.1 23.6719 12.24C24.5019 13.27 25.0019 14.58 25.0019 16C25.0019 17.42 24.5019 18.73 23.6719 19.76C24.0919 19.9 24.5319 20 25.0019 20Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 21C16.33 21 11 22.34 11 25V27C11 27.55 11.45 28 12 28H26C26.55 28 27 27.55 27 27V25C27 22.34 21.67 21 19 21Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_401_23565">
        <rect width="24" height="24" fill="white" transform="translate(10 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const NotificationIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="white"
      className="side-bar-icon-rect"
    />
    <path
      d="M23.7499 28C23.7499 28.1989 23.6709 28.3897 23.5302 28.5303C23.3896 28.671 23.1988 28.75 22.9999 28.75H16.9999C16.801 28.75 16.6102 28.671 16.4696 28.5303C16.3289 28.3897 16.2499 28.1989 16.2499 28C16.2499 27.8011 16.3289 27.6103 16.4696 27.4697C16.6102 27.329 16.801 27.25 16.9999 27.25H22.9999C23.1988 27.25 23.3896 27.329 23.5302 27.4697C23.6709 27.6103 23.7499 27.8011 23.7499 28ZM28.7946 23.4944C28.2733 22.5981 27.4999 20.0622 27.4999 16.75C27.4999 14.7609 26.7097 12.8532 25.3032 11.4467C23.8967 10.0402 21.989 9.25 19.9999 9.25C18.0108 9.25 16.1031 10.0402 14.6966 11.4467C13.2901 12.8532 12.4999 14.7609 12.4999 16.75C12.4999 20.0631 11.7255 22.5981 11.2052 23.4944C11.0723 23.7222 11.0019 23.9811 11.001 24.2449C11.0001 24.5086 11.0687 24.768 11.2 24.9967C11.3313 25.2255 11.5207 25.4156 11.7489 25.5478C11.9771 25.6801 12.2361 25.7498 12.4999 25.75H27.4999C27.7636 25.7496 28.0225 25.6798 28.2506 25.5475C28.4787 25.4151 28.6678 25.225 28.799 24.9963C28.9302 24.7676 28.9988 24.5083 28.9979 24.2446C28.9969 23.9809 28.9265 23.7222 28.7936 23.4944H28.7946Z"
      fill="#6B7280"
    />
  </svg>
);

export const AboutUsIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.5984 20.0004C31.5984 22.5465 30.587 24.9883 28.7867 26.7886C26.9863 28.589 24.5445 29.6004 21.9984 29.6004C19.4524 29.6004 17.0106 28.589 15.2102 26.7886C13.4099 24.9883 12.3984 22.5465 12.3984 20.0004C12.3984 17.4543 13.4099 15.0125 15.2102 13.2122C17.0106 11.4118 19.4524 10.4004 21.9984 10.4004C24.5445 10.4004 26.9863 11.4118 28.7867 13.2122C30.587 15.0125 31.5984 17.4543 31.5984 20.0004ZM23.1984 15.2004C23.1984 15.5187 23.072 15.8239 22.847 16.0489C22.6219 16.274 22.3167 16.4004 21.9984 16.4004C21.6802 16.4004 21.375 16.274 21.1499 16.0489C20.9249 15.8239 20.7984 15.5187 20.7984 15.2004C20.7984 14.8821 20.9249 14.5769 21.1499 14.3519C21.375 14.1268 21.6802 14.0004 21.9984 14.0004C22.3167 14.0004 22.6219 14.1268 22.847 14.3519C23.072 14.5769 23.1984 14.8821 23.1984 15.2004ZM20.7984 18.8004C20.4802 18.8004 20.175 18.9268 19.9499 19.1519C19.7249 19.3769 19.5984 19.6821 19.5984 20.0004C19.5984 20.3187 19.7249 20.6239 19.9499 20.8489C20.175 21.074 20.4802 21.2004 20.7984 21.2004V24.8004C20.7984 25.1187 20.9249 25.4239 21.1499 25.6489C21.375 25.874 21.6802 26.0004 21.9984 26.0004H23.1984C23.5167 26.0004 23.8219 25.874 24.047 25.6489C24.272 25.4239 24.3984 25.1187 24.3984 24.8004C24.3984 24.4821 24.272 24.1769 24.047 23.9519C23.8219 23.7268 23.5167 23.6004 23.1984 23.6004V20.0004C23.1984 19.6821 23.072 19.3769 22.847 19.1519C22.6219 18.9268 22.3167 18.8004 21.9984 18.8004H20.7984Z"
      fill="white"
    />
  </svg>
);

export const CMSIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <path
      d="M22.4737 10.4965C22.3243 10.4324 22.1635 10.3994 22.0009 10.3994C21.8384 10.3994 21.6775 10.4324 21.5281 10.4965L13.1281 14.0965C12.9117 14.1887 12.7271 14.3425 12.5973 14.5388C12.4676 14.7351 12.3984 14.9652 12.3984 15.2005C12.3984 15.4358 12.4676 15.6659 12.5973 15.8622C12.7271 16.0584 12.9117 16.2123 13.1281 16.3045L16.3009 17.6617C16.4187 17.5285 16.5646 17.4231 16.7281 17.3533L21.5281 15.2965C21.6734 15.2317 21.8301 15.1965 21.989 15.1929C22.148 15.1892 22.3061 15.2172 22.4542 15.2752C22.6023 15.3332 22.7374 15.42 22.8516 15.5306C22.9658 15.6413 23.0569 15.7735 23.1196 15.9197C23.1822 16.0659 23.2152 16.223 23.2166 16.382C23.218 16.541 23.1878 16.6988 23.1277 16.846C23.0676 16.9932 22.9788 17.127 22.8666 17.2397C22.7543 17.3523 22.6208 17.4415 22.4737 17.5021L19.2013 18.9061L21.5293 19.9033C21.6786 19.9672 21.8392 20.0001 22.0015 20.0001C22.1639 20.0001 22.3245 19.9672 22.4737 19.9033L30.8737 16.3033C31.0895 16.2107 31.2734 16.0569 31.4026 15.8609C31.5318 15.6649 31.6006 15.4353 31.6006 15.2005C31.6006 14.9657 31.5318 14.7361 31.4026 14.5401C31.2734 14.3441 31.0895 14.1902 30.8737 14.0977L22.4737 10.4977V10.4965ZM13.9729 19.2769L16.0009 20.1445V25.0669C15.5854 24.9724 15.1647 24.9027 14.7409 24.8581C14.4675 24.8293 14.2122 24.7076 14.0178 24.5132C13.8234 24.3188 13.7017 24.0635 13.6729 23.7901C13.5151 22.2792 13.6166 20.7524 13.9729 19.2757V19.2769ZM21.1609 27.8881C20.3498 27.0921 19.4184 26.4288 18.4009 25.9225V21.1741L20.5825 22.1101C21.0307 22.3022 21.5133 22.4013 22.0009 22.4013C22.4886 22.4013 22.9711 22.3022 23.4193 22.1101L30.0289 19.2769C30.3874 20.7533 30.4889 22.2804 30.3289 23.7913C30.3002 24.0647 30.1784 24.32 29.984 24.5144C29.7896 24.7088 29.5344 24.8305 29.2609 24.8593C26.84 25.1137 24.5768 26.1814 22.8409 27.8881C22.6166 28.108 22.315 28.2311 22.0009 28.2311C21.6868 28.2311 21.3853 28.108 21.1609 27.8881ZM17.2009 29.6005C17.5192 29.6005 17.8244 29.4741 18.0495 29.249C18.2745 29.024 18.4009 28.7187 18.4009 28.4005V25.9225C17.6377 25.5433 16.832 25.2565 16.0009 25.0681V28.4005C16.0009 28.7187 16.1274 29.024 16.3524 29.249C16.5775 29.4741 16.8827 29.6005 17.2009 29.6005Z"
      fill="white"
    />
  </svg>
);

export const CloudIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.2468 19.152C31.4718 19.377 31.5982 19.6822 31.5982 20.0004C31.5982 20.3186 31.4718 20.6238 31.2468 20.8488L22.8468 29.2488C22.6218 29.4738 22.3166 29.6001 21.9984 29.6001C21.6802 29.6001 21.3751 29.4738 21.15 29.2488L12.75 20.8488C12.6384 20.7375 12.5499 20.6053 12.4896 20.4597C12.4293 20.3141 12.3983 20.158 12.3984 20.0004V14.0004C12.3984 13.0456 12.7777 12.1299 13.4529 11.4548C14.128 10.7797 15.0437 10.4004 15.9984 10.4004H21.9984C22.3056 10.4004 22.6128 10.518 22.8468 10.752L31.2468 19.152ZM15.9984 15.2004C16.3167 15.2004 16.6219 15.074 16.847 14.8489C17.072 14.6239 17.1984 14.3187 17.1984 14.0004C17.1984 13.6821 17.072 13.3769 16.847 13.1519C16.6219 12.9268 16.3167 12.8004 15.9984 12.8004C15.6802 12.8004 15.375 12.9268 15.1499 13.1519C14.9249 13.3769 14.7984 13.6821 14.7984 14.0004C14.7984 14.3187 14.9249 14.6239 15.1499 14.8489C15.375 15.074 15.6802 15.2004 15.9984 15.2004Z"
      fill="white"
    />
  </svg>
);

export const PasswordIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="none"
      className="side-bar-icon-rect"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.5999 17.5993C31.6002 18.7239 31.3371 19.833 30.8316 20.8376C30.3262 21.8422 29.5924 22.7144 28.6891 23.3844C27.7859 24.0543 26.7382 24.5034 25.6301 24.6955C24.5221 24.8877 23.3844 24.8176 22.3083 24.4909L21.9999 24.7993L20.7999 25.9993L19.5999 27.1993H17.1999V29.5993H12.3999V24.7993L17.5083 19.6909C17.2088 18.7009 17.1262 17.658 17.266 16.6332C17.4057 15.6084 17.7647 14.6258 18.3183 13.7522C18.8719 12.8785 19.6073 12.1344 20.4743 11.5705C21.3414 11.0066 22.3197 10.6361 23.3428 10.4843C24.3659 10.3324 25.4097 10.4028 26.4031 10.6905C27.3966 10.9783 28.3163 11.4767 29.0999 12.1519C29.8834 12.827 30.5123 13.6631 30.9437 14.6031C31.3751 15.5431 31.5989 16.565 31.5999 17.5993ZM24.3999 12.7993C24.0816 12.7993 23.7764 12.9257 23.5514 13.1508C23.3263 13.3758 23.1999 13.681 23.1999 13.9993C23.1999 14.3176 23.3263 14.6228 23.5514 14.8478C23.7764 15.0729 24.0816 15.1993 24.3999 15.1993C25.0364 15.1993 25.6469 15.4522 26.097 15.9023C26.547 16.3523 26.7999 16.9628 26.7999 17.5993C26.7999 17.9176 26.9263 18.2228 27.1514 18.4478C27.3764 18.6729 27.6816 18.7993 27.9999 18.7993C28.3182 18.7993 28.6234 18.6729 28.8484 18.4478C29.0735 18.2228 29.1999 17.9176 29.1999 17.5993C29.1999 16.3263 28.6942 15.1054 27.794 14.2052C26.8938 13.305 25.6729 12.7993 24.3999 12.7993Z"
      fill="none"
    />
  </svg>
);

export const SettingsIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7861 11.8044C23.3301 9.93239 20.6661 9.93239 20.2101 11.8044C20.1421 12.0857 20.0085 12.3469 19.8204 12.5669C19.6323 12.7868 19.3949 12.9592 19.1276 13.0701C18.8602 13.181 18.5705 13.2272 18.2819 13.2049C17.9933 13.1826 17.7141 13.0926 17.4669 12.942C15.8205 11.9388 13.9365 13.8228 14.9397 15.4692C15.5877 16.5324 15.0129 17.9196 13.8033 18.2136C11.9301 18.6684 11.9301 21.3336 13.8033 21.7872C14.0847 21.8554 14.346 21.989 14.566 22.1773C14.7859 22.3655 14.9583 22.6031 15.069 22.8706C15.1798 23.1381 15.2258 23.4279 15.2033 23.7166C15.1809 24.0052 15.0906 24.2845 14.9397 24.5316C13.9365 26.178 15.8205 28.062 17.4669 27.0588C17.7141 26.908 17.9933 26.8177 18.282 26.7952C18.5706 26.7727 18.8605 26.8187 19.128 26.9295C19.3954 27.0403 19.633 27.2126 19.8213 27.4326C20.0095 27.6525 20.1432 27.9138 20.2113 28.1952C20.6661 30.0684 23.3313 30.0684 23.7849 28.1952C23.8533 27.914 23.9871 27.6528 24.1754 27.4331C24.3637 27.2133 24.6012 27.041 24.8686 26.9303C25.136 26.8195 25.4258 26.7735 25.7144 26.7958C26.0029 26.8181 26.2822 26.9082 26.5293 27.0588C28.1757 28.062 30.0597 26.178 29.0565 24.5316C28.906 24.2844 28.8159 24.0052 28.7936 23.7166C28.7712 23.4281 28.8173 23.1383 28.928 22.8709C29.0387 22.6035 29.211 22.366 29.4308 22.1777C29.6506 21.9894 29.9117 21.8556 30.1929 21.7872C32.0661 21.3324 32.0661 18.6672 30.1929 18.2136C29.9116 18.1454 29.6503 18.0118 29.4303 17.8235C29.2104 17.6352 29.038 17.3977 28.9273 17.1302C28.8165 16.8627 28.7705 16.5729 28.7929 16.2842C28.8154 15.9956 28.9057 15.7163 29.0565 15.4692C30.0597 13.8228 28.1757 11.9388 26.5293 12.942C26.2822 13.0928 26.003 13.1831 25.7143 13.2056C25.4257 13.2281 25.1358 13.182 24.8683 13.0713C24.6008 12.9605 24.3633 12.7881 24.175 12.5682C23.9868 12.3483 23.8531 12.087 23.7849 11.8056L23.7861 11.8044ZM21.9981 23.6004C22.9529 23.6004 23.8686 23.2211 24.5437 22.546C25.2189 21.8708 25.5981 20.9552 25.5981 20.0004C25.5981 19.0456 25.2189 18.1299 24.5437 17.4548C23.8686 16.7797 22.9529 16.4004 21.9981 16.4004C21.0434 16.4004 20.1277 16.7797 19.4526 17.4548C18.7774 18.1299 18.3981 19.0456 18.3981 20.0004C18.3981 20.9552 18.7774 21.8708 19.4526 22.546C20.1277 23.2211 21.0434 23.6004 21.9981 23.6004V23.6004Z"
      fill="white"
    />
  </svg>
);

export const LearningPathIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0955 11.0698C25.8468 11.1684 25.5641 11.4351 25.4392 11.6887C25.296 11.9794 25.2748 12.4004 25.3881 12.7026C25.4944 12.9861 25.8186 13.3172 26.0811 13.4106L26.2654 13.4762L26.2548 14.7596C26.243 16.172 26.2446 16.1613 26.018 16.3526C25.8395 16.5034 25.6498 16.5194 24.1596 16.5094L22.7758 16.5L22.7645 16.3812L22.7532 16.2623L22.531 16.2852C21.2896 16.4128 20.1502 17.2172 19.5877 18.3629C18.6017 20.3716 19.5696 22.7338 21.6983 23.5135C21.9803 23.6168 22.4723 23.7257 22.6571 23.7257C22.7494 23.7257 22.7583 23.7148 22.7583 23.6026V23.4795H24.2308C25.8137 23.4795 25.8508 23.4833 26.0455 23.6658C26.2434 23.8513 26.2432 23.85 26.2548 25.2376L26.2654 26.521L26.0811 26.5866C25.8186 26.68 25.4944 27.0111 25.3881 27.2945C25.2748 27.5968 25.296 28.0178 25.4392 28.3085C25.5696 28.5731 25.848 28.8302 26.1128 28.9304C26.4012 29.0395 26.8304 29.0182 27.1024 28.8813C27.3551 28.7541 27.5616 28.548 27.6828 28.3021C27.8227 28.0181 27.8429 27.5938 27.7307 27.2945C27.6241 27.0104 27.3048 26.6852 27.0324 26.5833L26.8397 26.5113L26.8222 25.1624C26.805 23.841 26.803 23.8099 26.7224 23.6311C26.609 23.3794 26.3004 23.0904 26.0412 22.9931C25.8448 22.9193 25.7917 22.917 24.2984 22.917H22.7583V22.3896V21.8621H24.3938H26.0293L27.0826 22.4781C27.6619 22.8169 28.1557 23.1067 28.1798 23.122C28.2145 23.144 28.2119 23.1848 28.1674 23.3158C28.1284 23.4306 28.1152 23.5653 28.1244 23.7531C28.1482 24.2373 28.4008 24.6204 28.8385 24.8361C29.0242 24.9276 29.0828 24.9387 29.3796 24.9387C29.6916 24.9387 29.7261 24.9313 29.932 24.8192C30.1947 24.6762 30.3709 24.4897 30.4959 24.2222C30.5754 24.0521 30.5882 23.978 30.5882 23.6905C30.5882 23.3911 30.5776 23.3355 30.4857 23.1533C30.3648 22.9136 30.1087 22.6612 29.8777 22.5541C29.7427 22.4915 29.6481 22.4775 29.3621 22.4775C29.0508 22.4775 28.9899 22.4882 28.8157 22.5741C28.7078 22.6273 28.6083 22.6708 28.5945 22.6708C28.5807 22.6708 28.0415 22.3623 27.3962 21.9852L26.223 21.2996H24.4907H22.7583V20.7897V20.2799H25.4476H28.137L28.1971 20.4498C28.4425 21.1431 29.2871 21.4702 29.936 21.1231C30.1902 20.9872 30.3661 20.7996 30.4963 20.526C30.5756 20.3592 30.5882 20.2867 30.5882 19.9978C30.5882 19.6906 30.5788 19.6438 30.4733 19.4288C30.3316 19.1399 30.0833 18.9061 29.8071 18.8016C29.6434 18.7397 29.5535 18.7287 29.3095 18.7408C28.9735 18.7574 28.7475 18.85 28.5038 19.071C28.3745 19.1883 28.1534 19.5662 28.1534 19.6702C28.1534 19.7091 27.6874 19.7173 25.4559 19.7173H22.7583V19.2075V18.6976L24.4837 18.6973L26.2091 18.697L27.3981 18.0002L28.5871 17.3034L28.7994 17.4116C28.9944 17.5109 29.0403 17.5197 29.3621 17.5197C29.6481 17.5197 29.7427 17.5057 29.8777 17.4431C30.1094 17.3357 30.3773 17.0717 30.4915 16.8385C30.5766 16.6645 30.5882 16.6003 30.5882 16.3059C30.5882 15.9986 30.5788 15.9519 30.4733 15.7368C30.3316 15.448 30.0833 15.2142 29.8071 15.1097C29.6442 15.0481 29.5523 15.0367 29.3095 15.0481C29.054 15.0601 28.9806 15.0788 28.7922 15.1797C28.3769 15.4023 28.1478 15.7675 28.1244 16.244C28.1151 16.433 28.1284 16.5665 28.1681 16.6833C28.1994 16.7756 28.2129 16.8556 28.198 16.861C28.1831 16.8665 27.6901 17.1553 27.1024 17.5029L26.0339 18.1349L24.3961 18.135L22.7583 18.135V17.6076V17.0802H24.2984C25.7913 17.0802 25.8448 17.0779 26.0413 17.0042C26.3213 16.8992 26.6418 16.5775 26.7464 16.2965C26.819 16.1014 26.8222 16.0395 26.8222 14.7923C26.8222 13.5847 26.8265 13.4901 26.8835 13.4712C27.2651 13.3447 27.6067 13.0324 27.7339 12.6937C27.8428 12.4039 27.8208 11.9753 27.6828 11.6951C27.5616 11.4493 27.3552 11.2433 27.1024 11.1157C26.8375 10.9821 26.3703 10.9607 26.0955 11.0698ZM20.3471 11.4303C20.2734 11.5091 20.2709 11.538 20.2709 12.3385V13.1652L19.9644 13.2815C19.3046 13.5318 18.5514 13.96 18.0407 14.3753C17.9027 14.4875 17.7596 14.5982 17.7226 14.6214C17.6643 14.6579 17.5639 14.6094 16.963 14.2544C16.2354 13.8245 16.1035 13.778 15.9851 13.9094C15.9533 13.9446 15.4937 14.7386 14.9637 15.6739C13.9512 17.4606 13.9219 17.5258 14.0722 17.6623C14.1119 17.6984 14.439 17.8955 14.7991 18.1003C15.3772 18.429 15.4535 18.4827 15.4504 18.5587C15.4486 18.6061 15.421 18.8234 15.3891 19.0416C15.3142 19.5554 15.314 20.3975 15.3887 20.9374C15.4202 21.1656 15.4479 21.391 15.45 21.4384C15.4534 21.5146 15.3782 21.5676 14.7991 21.8969C14.439 22.1017 14.1119 22.2988 14.0722 22.3349C14.0295 22.3737 14 22.444 14 22.5072C14 22.5822 14.2843 23.1173 14.9545 24.3038C15.4795 25.2332 15.9438 26.0292 15.9863 26.0727C16.0995 26.1883 16.2417 26.1728 16.4955 26.0172C16.6163 25.9432 16.9299 25.7551 17.1924 25.5993L17.6697 25.3159L17.9456 25.542C18.5249 26.0166 19.2886 26.4608 19.9644 26.7161L20.2709 26.832V27.6538V28.4756L20.357 28.5619L20.4429 28.6483H21.5146H22.5863L22.6723 28.5619L22.7583 28.4756V26.2289V23.9821L22.5043 23.9604C21.9683 23.9145 21.3252 23.6909 20.8113 23.3717C20.4015 23.1171 19.8509 22.5753 19.5879 22.1676C18.823 20.9824 18.7313 19.5225 19.3422 18.2551C19.726 17.4589 20.4344 16.7657 21.2622 16.3764C21.6268 16.2049 22.1282 16.0659 22.4868 16.0369L22.7583 16.015V13.7584V11.5018L22.6772 11.4254C22.5976 11.3503 22.577 11.3489 21.5097 11.3489H20.4233L20.3471 11.4303Z"
      fill="white"
    />
  </svg>
);

export const DailyActivitiesIcon = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="44"
      height="40"
      rx="6"
      fill="#164642"
      className="side-bar-icon-rect"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9391 15.583C22.6946 14.5791 21.2659 14.5791 21.0214 15.583C20.9849 15.7339 20.9132 15.874 20.8124 15.9919C20.7115 16.1099 20.5842 16.2023 20.4408 16.2618C20.2974 16.3213 20.142 16.346 19.9873 16.3341C19.8325 16.3221 19.6828 16.2738 19.5502 16.1931C18.6673 15.6551 17.6569 16.6654 18.1949 17.5484C18.5424 18.1186 18.2342 18.8625 17.5855 19.0202C16.5809 19.2641 16.5809 20.6934 17.5855 20.9366C17.7364 20.9732 17.8765 21.0448 17.9944 21.1458C18.1124 21.2468 18.2048 21.3742 18.2642 21.5176C18.3236 21.6611 18.3483 21.8165 18.3363 21.9713C18.3242 22.1261 18.2758 22.2759 18.1949 22.4084C17.6569 23.2913 18.6673 24.3017 19.5502 23.7637C19.6828 23.6828 19.8325 23.6344 19.9873 23.6223C20.1421 23.6103 20.2976 23.6349 20.441 23.6943C20.5845 23.7537 20.7119 23.8462 20.8128 23.9641C20.9138 24.0821 20.9855 24.2222 21.022 24.3731C21.2659 25.3777 22.6952 25.3777 22.9385 24.3731C22.9752 24.2223 23.0469 24.0823 23.1479 23.9644C23.2489 23.8465 23.3763 23.7541 23.5197 23.6948C23.6631 23.6354 23.8185 23.6107 23.9732 23.6226C24.128 23.6346 24.2777 23.6829 24.4103 23.7637C25.2932 24.3017 26.3036 23.2913 25.7656 22.4084C25.6849 22.2758 25.6365 22.1261 25.6246 21.9713C25.6126 21.8166 25.6373 21.6612 25.6967 21.5178C25.7561 21.3744 25.8485 21.247 25.9663 21.146C26.0842 21.045 26.2242 20.9733 26.375 20.9366C27.3796 20.6927 27.3796 19.2634 26.375 19.0202C26.2242 18.9836 26.084 18.9119 25.9661 18.811C25.8481 18.71 25.7557 18.5826 25.6963 18.4392C25.6369 18.2957 25.6122 18.1403 25.6242 17.9855C25.6363 17.8307 25.6847 17.6809 25.7656 17.5484C26.3036 16.6654 25.2932 15.6551 24.4103 16.1931C24.2778 16.274 24.128 16.3224 23.9732 16.3345C23.8184 16.3465 23.663 16.3218 23.5195 16.2624C23.3761 16.203 23.2487 16.1106 23.1477 15.9926C23.0467 15.8747 22.9751 15.7346 22.9385 15.5837L22.9391 15.583ZM21.9803 21.909C22.4923 21.909 22.9834 21.7056 23.3454 21.3435C23.7075 20.9815 23.9109 20.4904 23.9109 19.9784C23.9109 19.4664 23.7075 18.9753 23.3454 18.6132C22.9834 18.2512 22.4923 18.0478 21.9803 18.0478C21.4682 18.0478 20.9772 18.2512 20.6151 18.6132C20.253 18.9753 20.0496 19.4664 20.0496 19.9784C20.0496 20.4904 20.253 20.9815 20.6151 21.3435C20.9772 21.7056 21.4682 21.909 21.9803 21.909Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1903 11.036C17.3621 11.393 14.2104 14.0835 13.2687 17.7985C12.9377 19.1041 12.9118 20.5413 13.195 21.8827C13.3297 22.5206 13.6314 23.4114 13.8678 23.869L13.9177 23.9655L14.3825 23.7332C14.6381 23.6055 14.8521 23.4967 14.8579 23.4914C14.8638 23.4862 14.7989 23.3179 14.7137 23.1176C14.0111 21.465 13.8829 19.6955 14.3405 17.9627C14.9283 15.7364 16.4636 13.8746 18.536 12.8749C20.9595 11.7059 23.7915 11.84 26.133 13.2348L26.4791 13.4409L26.0486 13.4508L25.6182 13.4607V13.9867V14.5127H27.0941H28.57V13.0719V11.6311H28.0262H27.4823L27.4727 12.2292L27.4631 12.8273L27.1644 12.6202C25.4416 11.4257 23.2485 10.8441 21.1903 11.036ZM29.3807 15.813C29.1404 15.9489 28.9361 16.0677 28.9268 16.0771C28.9174 16.0865 29.0066 16.2957 29.1251 16.5422C29.9629 18.2855 30.1441 20.1356 29.6608 22.0103C29.0234 24.4822 27.2035 26.501 24.7923 27.4107C23.966 27.7225 23.2178 27.8647 22.2616 27.8919C21.5257 27.9129 21.115 27.8791 20.4226 27.7406C19.2476 27.5057 17.9819 26.9259 17.1003 26.219L16.9637 26.1094H17.5308H18.0979V25.5644V25.0193L16.5604 25.0284L15.023 25.0376L15.0138 26.5575L15.0047 28.0774H15.5497H16.0948V27.4405C16.0948 26.8272 16.0972 26.8055 16.1598 26.8519C16.1955 26.8784 16.3799 27.0175 16.5696 27.1609C17.7874 28.0815 19.2485 28.6821 20.8213 28.9084C21.3368 28.9826 22.6327 28.9935 23.1055 28.9276C24.8114 28.6899 26.1934 28.1186 27.5328 27.0974C27.9705 26.7637 28.6851 26.0587 29.0362 25.6141C31.1969 22.8783 31.6078 19.2105 30.1038 16.0842C29.8212 15.4969 29.8925 15.5236 29.3807 15.813Z"
      fill="white"
    />
  </svg>
);

export const ScheduleIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="none"
      className="side-bar-icon-rect"
    />
    <path
      d="M27.5 10H25.25V9.25C25.25 9.05109 25.171 8.86032 25.0303 8.71967C24.8897 8.57902 24.6989 8.5 24.5 8.5C24.3011 8.5 24.1103 8.57902 23.9697 8.71967C23.829 8.86032 23.75 9.05109 23.75 9.25V10H16.25V9.25C16.25 9.05109 16.171 8.86032 16.0303 8.71967C15.8897 8.57902 15.6989 8.5 15.5 8.5C15.3011 8.5 15.1103 8.57902 14.9697 8.71967C14.829 8.86032 14.75 9.05109 14.75 9.25V10H12.5C12.1022 10 11.7206 10.158 11.4393 10.4393C11.158 10.7206 11 11.1022 11 11.5V26.5C11 26.8978 11.158 27.2794 11.4393 27.5607C11.7206 27.842 12.1022 28 12.5 28H27.5C27.8978 28 28.2794 27.842 28.5607 27.5607C28.842 27.2794 29 26.8978 29 26.5V11.5C29 11.1022 28.842 10.7206 28.5607 10.4393C28.2794 10.158 27.8978 10 27.5 10ZM27.5 14.5H12.5V11.5H14.75V12.25C14.75 12.4489 14.829 12.6397 14.9697 12.7803C15.1103 12.921 15.3011 13 15.5 13C15.6989 13 15.8897 12.921 16.0303 12.7803C16.171 12.6397 16.25 12.4489 16.25 12.25V11.5H23.75V12.25C23.75 12.4489 23.829 12.6397 23.9697 12.7803C24.1103 12.921 24.3011 13 24.5 13C24.6989 13 24.8897 12.921 25.0303 12.7803C25.171 12.6397 25.25 12.4489 25.25 12.25V11.5H27.5V14.5Z"
      fill="none"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="none"
      className="side-bar-icon-rect"
    />
    <path
      d="M27.5 10H25.25V9.25C25.25 9.05109 25.171 8.86032 25.0303 8.71967C24.8897 8.57902 24.6989 8.5 24.5 8.5C24.3011 8.5 24.1103 8.57902 23.9697 8.71967C23.829 8.86032 23.75 9.05109 23.75 9.25V10H16.25V9.25C16.25 9.05109 16.171 8.86032 16.0303 8.71967C15.8897 8.57902 15.6989 8.5 15.5 8.5C15.3011 8.5 15.1103 8.57902 14.9697 8.71967C14.829 8.86032 14.75 9.05109 14.75 9.25V10H12.5C12.1022 10 11.7206 10.158 11.4393 10.4393C11.158 10.7206 11 11.1022 11 11.5V26.5C11 26.8978 11.158 27.2794 11.4393 27.5607C11.7206 27.842 12.1022 28 12.5 28H27.5C27.8978 28 28.2794 27.842 28.5607 27.5607C28.842 27.2794 29 26.8978 29 26.5V11.5C29 11.1022 28.842 10.7206 28.5607 10.4393C28.2794 10.158 27.8978 10 27.5 10ZM23.9056 19.5306L19.4056 24.0306C19.336 24.1004 19.2533 24.1557 19.1622 24.1934C19.0712 24.2312 18.9736 24.2506 18.875 24.2506C18.7764 24.2506 18.6788 24.2312 18.5878 24.1934C18.4967 24.1557 18.414 24.1004 18.3444 24.0306L16.0944 21.7806C15.9536 21.6399 15.8746 21.449 15.8746 21.25C15.8746 21.051 15.9536 20.8601 16.0944 20.7194C16.2351 20.5786 16.426 20.4996 16.625 20.4996C16.824 20.4996 17.0149 20.5786 17.1556 20.7194L18.875 22.4397L22.8444 18.4694C22.9141 18.3997 22.9968 18.3444 23.0878 18.3067C23.1789 18.269 23.2765 18.2496 23.375 18.2496C23.4735 18.2496 23.5711 18.269 23.6622 18.3067C23.7532 18.3444 23.8359 18.3997 23.9056 18.4694C23.9753 18.5391 24.0306 18.6218 24.0683 18.7128C24.106 18.8039 24.1254 18.9015 24.1254 19C24.1254 19.0985 24.106 19.1961 24.0683 19.2872C24.0306 19.3782 23.9753 19.4609 23.9056 19.5306ZM12.5 14.5V11.5H14.75V12.25C14.75 12.4489 14.829 12.6397 14.9697 12.7803C15.1103 12.921 15.3011 13 15.5 13C15.6989 13 15.8897 12.921 16.0303 12.7803C16.171 12.6397 16.25 12.4489 16.25 12.25V11.5H23.75V12.25C23.75 12.4489 23.829 12.6397 23.9697 12.7803C24.1103 12.921 24.3011 13 24.5 13C24.6989 13 24.8897 12.921 25.0303 12.7803C25.171 12.6397 25.25 12.4489 25.25 12.25V11.5H27.5V14.5H12.5Z"
      fill="none"
    />
  </svg>
);

export const SelfReflectionIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="none"
      className="side-bar-icon-rect"
    />
    <path
      d="M29.3113 13.8782L25.1216 9.68946C24.9823 9.55014 24.8169 9.43962 24.6349 9.36421C24.4529 9.28881 24.2578 9.25 24.0608 9.25C23.8638 9.25 23.6687 9.28881 23.4867 9.36421C23.3047 9.43962 23.1393 9.55014 23 9.68946L11.4397 21.2498C11.2998 21.3886 11.1889 21.5538 11.1134 21.7358C11.0379 21.9178 10.9994 22.113 11 22.3101V26.4998C11 26.8976 11.158 27.2791 11.4393 27.5604C11.7207 27.8417 12.1022 27.9998 12.5 27.9998H28.25C28.4489 27.9998 28.6397 27.9208 28.7803 27.7801C28.921 27.6395 29 27.4487 29 27.2498C29 27.0509 28.921 26.8601 28.7803 26.7194C28.6397 26.5788 28.4489 26.4998 28.25 26.4998H18.8113L29.3113 15.9998C29.4506 15.8605 29.5611 15.6951 29.6365 15.5131C29.7119 15.3311 29.7507 15.136 29.7507 14.939C29.7507 14.742 29.7119 14.5469 29.6365 14.3649C29.5611 14.1829 29.4506 14.0175 29.3113 13.8782ZM15.4363 24.6248L23.9056 16.1554L25.4703 17.7191L17 26.1895L15.4363 24.6248ZM22.8425 15.0941L14.375 23.5645L12.8103 21.9998L21.2806 13.5304L22.8425 15.0941ZM12.5 23.8101L15.1897 26.4998H12.5V23.8101Z"
      fill="none"
    />
  </svg>
);

export const AddUserIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="white"
      className="side-bar-icon-rect"
    />
    <path
      d="M20.0001 14.125C20.816 14.125 21.6135 14.3669 22.2919 14.8202C22.9702 15.2735 23.4989 15.9177 23.8111 16.6714C24.1234 17.4252 24.2051 18.2546 24.0459 19.0548C23.8867 19.8549 23.4939 20.5899 22.917 21.1668C22.3401 21.7437 21.6051 22.1366 20.8049 22.2957C20.0047 22.4549 19.1753 22.3732 18.4216 22.061C17.6678 21.7488 17.0236 21.2201 16.5703 20.5417C16.1171 19.8634 15.8751 19.0659 15.8751 18.25C15.8751 17.156 16.3097 16.1068 17.0833 15.3332C17.8569 14.5596 18.9061 14.125 20.0001 14.125ZM24.5001 13H26.0001V14.5C26.0001 14.6989 26.0792 14.8897 26.2198 15.0303C26.3605 15.171 26.5512 15.25 26.7501 15.25C26.9491 15.25 27.1398 15.171 27.2805 15.0303C27.4211 14.8897 27.5001 14.6989 27.5001 14.5V13H29.0001C29.1991 13 29.3898 12.921 29.5305 12.7803C29.6711 12.6397 29.7501 12.4489 29.7501 12.25C29.7501 12.0511 29.6711 11.8603 29.5305 11.7197C29.3898 11.579 29.1991 11.5 29.0001 11.5H27.5001V10C27.5001 9.8011 27.4211 9.61033 27.2805 9.46968C27.1398 9.32903 26.9491 9.25001 26.7501 9.25001C26.5512 9.25001 26.3605 9.32903 26.2198 9.46968C26.0792 9.61033 26.0001 9.8011 26.0001 10V11.5H24.5001C24.3012 11.5 24.1105 11.579 23.9698 11.7197C23.8292 11.8603 23.7501 12.0511 23.7501 12.25C23.7501 12.4489 23.8292 12.6397 23.9698 12.7803C24.1105 12.921 24.3012 13 24.5001 13ZM28.7517 16.7603C28.5555 16.7932 28.3804 16.9026 28.2649 17.0645C28.1494 17.2264 28.103 17.4276 28.1358 17.6238C28.2119 18.0786 28.2502 18.5389 28.2501 19C28.2519 21.0196 27.5097 22.969 26.1651 24.4759C25.6196 23.6853 24.927 23.007 24.1251 22.4781C24.0567 22.4327 23.9752 22.4111 23.8932 22.4165C23.8112 22.4219 23.7333 22.4541 23.6714 22.5081C22.6524 23.3898 21.35 23.8751 20.0025 23.8751C18.655 23.8751 17.3526 23.3898 16.3336 22.5081C16.2713 22.453 16.1925 22.4201 16.1095 22.4147C16.0265 22.4093 15.9441 22.4316 15.8751 22.4781C15.072 23.0065 14.3784 23.6848 13.8323 24.4759C12.7772 23.287 12.0881 21.8185 11.8478 20.2472C11.6075 18.6758 11.8262 17.0685 12.4778 15.6185C13.1293 14.1686 14.1859 12.9377 15.5204 12.074C16.8549 11.2103 18.4105 10.7506 20.0001 10.75C20.4613 10.7499 20.9216 10.7882 21.3764 10.8644C21.5717 10.8952 21.7712 10.8477 21.9317 10.7321C22.0921 10.6165 22.2004 10.4423 22.233 10.2473C22.2656 10.0523 22.2199 9.85232 22.1059 9.69083C21.9918 9.52935 21.8186 9.41944 21.6239 9.38501C19.5871 9.04237 17.4942 9.35589 15.6472 10.2803C13.8002 11.2047 12.2948 12.6922 11.3483 14.5279C10.4018 16.3637 10.0633 18.4528 10.3815 20.4935C10.6997 22.5342 11.6582 24.421 13.1187 25.8815C14.5791 27.342 16.4659 28.3005 18.5067 28.6187C20.5474 28.9369 22.6364 28.5983 24.4722 27.6518C26.308 26.7054 27.7954 25.2 28.7199 23.353C29.6443 21.506 29.9578 19.413 29.6151 17.3763C29.5823 17.1801 29.4729 17.005 29.311 16.8895C29.1491 16.774 28.9479 16.7275 28.7517 16.7603Z"
      fill="#6B7280"
    />
  </svg>
);

export const NoteBookIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="white"
      className="side-bar-icon-rect"
    />
    <path
      d="M27.5 10H12.5C12.1022 10 11.7206 10.158 11.4393 10.4393C11.158 10.7206 11 11.1022 11 11.5V26.5C11 26.8978 11.158 27.2794 11.4393 27.5607C11.7206 27.842 12.1022 28 12.5 28H27.5C27.8978 28 28.2794 27.842 28.5607 27.5607C28.842 27.2794 29 26.8978 29 26.5V11.5C29 11.1022 28.842 10.7206 28.5607 10.4393C28.2794 10.158 27.8978 10 27.5 10ZM15.5 26.5H12.5V11.5H15.5V26.5ZM24.5 21.25H18.5C18.3011 21.25 18.1103 21.171 17.9697 21.0303C17.829 20.8897 17.75 20.6989 17.75 20.5C17.75 20.3011 17.829 20.1103 17.9697 19.9697C18.1103 19.829 18.3011 19.75 18.5 19.75H24.5C24.6989 19.75 24.8897 19.829 25.0303 19.9697C25.171 20.1103 25.25 20.3011 25.25 20.5C25.25 20.6989 25.171 20.8897 25.0303 21.0303C24.8897 21.171 24.6989 21.25 24.5 21.25ZM24.5 18.25H18.5C18.3011 18.25 18.1103 18.171 17.9697 18.0303C17.829 17.8897 17.75 17.6989 17.75 17.5C17.75 17.3011 17.829 17.1103 17.9697 16.9697C18.1103 16.829 18.3011 16.75 18.5 16.75H24.5C24.6989 16.75 24.8897 16.829 25.0303 16.9697C25.171 17.1103 25.25 17.3011 25.25 17.5C25.25 17.6989 25.171 17.8897 25.0303 18.0303C24.8897 18.171 24.6989 18.25 24.5 18.25Z"
      fill="#6B7280"
    />
  </svg>
);

export const ProfileIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="white"
      className="side-bar-icon-rect"
    />
    <mask
      id="mask0_1401_851"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="7"
      width="24"
      height="24"
    >
      <rect x="8" y="7" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1401_851)">
      <path
        d="M20 19C18.9 19 17.9583 18.6083 17.175 17.825C16.3917 17.0417 16 16.1 16 15C16 13.9 16.3917 12.9583 17.175 12.175C17.9583 11.3917 18.9 11 20 11C21.1 11 22.0417 11.3917 22.825 12.175C23.6083 12.9583 24 13.9 24 15C24 16.1 23.6083 17.0417 22.825 17.825C22.0417 18.6083 21.1 19 20 19ZM14 27C13.45 27 12.9792 26.8042 12.5875 26.4125C12.1958 26.0208 12 25.55 12 25V24.2C12 23.6333 12.1458 23.1125 12.4375 22.6375C12.7292 22.1625 13.1167 21.8 13.6 21.55C14.6333 21.0333 15.6833 20.6458 16.75 20.3875C17.8167 20.1292 18.9 20 20 20C21.1 20 22.1833 20.1292 23.25 20.3875C24.3167 20.6458 25.3667 21.0333 26.4 21.55C26.8833 21.8 27.2708 22.1625 27.5625 22.6375C27.8542 23.1125 28 23.6333 28 24.2V25C28 25.55 27.8042 26.0208 27.4125 26.4125C27.0208 26.8042 26.55 27 26 27H14Z"
        fill="#6B7280"
      />
    </g>
  </svg>
);

export const WorldIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <rect
      width="40"
      height="37"
      rx="6"
      fill="#FCECF0"
      className="side-bar-icon-rect"
    />
    <path
      d="M20 29.9999C17.0619 29.9999 14.2992 28.8559 12.2216 26.7783C10.1441 24.7008 9 21.9378 9 19C9 16.0621 10.1441 13.2992 12.2216 11.2216C14.2991 9.14408 17.0621 8 20 8C22.9378 8 25.7007 9.14405 27.7783 11.2216C29.8558 13.2991 30.9999 16.0621 30.9999 19C30.9999 21.9378 29.8559 24.7007 27.7783 26.7783C25.7008 28.8558 22.9378 29.9999 20 29.9999ZM20 9.69179C14.8674 9.69179 10.6918 13.8674 10.6918 19C10.6918 24.1325 14.8674 28.3081 20 28.3081C25.1325 28.3081 29.3081 24.1325 29.3081 19C29.3081 13.8674 25.1325 9.69179 20 9.69179Z"
      fill="#D71440"
    />
    <path
      d="M19.9997 29.9999C16.5086 29.9999 13.7734 25.1682 13.7734 19C13.7734 12.8317 16.5084 8 19.9997 8C23.491 8 26.2259 12.8317 26.2259 19C26.2259 25.1682 23.491 29.9999 19.9997 29.9999ZM19.9997 9.69179C18.9072 9.69179 17.7933 10.6113 16.9436 12.2162C15.9908 14.0144 15.4666 16.424 15.4666 18.9999C15.4666 21.5758 15.9908 23.9853 16.9436 25.7836C17.7933 27.3873 18.9073 28.308 19.9997 28.308C21.0921 28.308 22.2061 27.3884 23.0558 25.7836C24.0086 23.9853 24.5328 21.5758 24.5328 18.9999C24.5328 16.424 24.0086 14.0144 23.0558 12.2162C22.2061 10.6124 21.0921 9.69179 19.9997 9.69179Z"
      fill="#D71440"
    />
    <path
      d="M20.0008 30C19.5335 30 19.1543 29.6208 19.1543 29.1535V8.84647C19.1543 8.3792 19.5335 8 20.0008 8C20.468 8 20.8472 8.3792 20.8472 8.84647V29.1546C20.8472 29.6208 20.468 30 20.0008 30Z"
      fill="#D71440"
    />
    <path
      d="M29.5877 23.1929H10.4109C9.94365 23.1929 9.56445 22.8138 9.56445 22.3465C9.56445 21.8792 9.94365 21.5 10.4109 21.5H29.5888C30.0561 21.5 30.4353 21.8792 30.4353 22.3465C30.4342 22.8138 30.0561 23.1929 29.5877 23.1929Z"
      fill="#D71440"
    />
    <path
      d="M29.5877 16.4996H10.4109C9.94365 16.4996 9.56445 16.1204 9.56445 15.6531C9.56445 15.1858 9.94365 14.8066 10.4109 14.8066H29.5888C30.0561 14.8066 30.4353 15.1858 30.4353 15.6531C30.4342 16.1204 30.0561 16.4996 29.5877 16.4996Z"
      fill="#D71440"
    />
  </svg>
);
